"use strict";
var jun;
(function (jun) {
    var storefront;
    (function (storefront) {
        function getOptions(params) {
            return {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Shopify-Storefront-Access-Token": jun.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
                    "Accept-Language": "*",
                },
                body: JSON.stringify(params),
            };
        }
        async function exeStoreFront(params, successFunc) {
            await jun.FetchUtil.fetch(jun.SHOPIFY_STOREFRONT_URL, getOptions(params), successFunc);
        }
        storefront.exeStoreFront = exeStoreFront;
    })(storefront = jun.storefront || (jun.storefront = {}));
})(jun || (jun = {}));
/// <reference path="../../library/env.d.ts" />
var jun;
(function (jun) {
    jun.SHOPIFY_STOREFRONT_URL = "/api/2026-01/graphql";
    jun.HOST_URL = location.protocol + "//" + location.hostname;
    jun.NOW_URL = jun.HOST_URL + location.pathname;
    jun.CART_URL = jun.HOST_URL + "/cart";
    jun.COMMA = ",";
    jun.HYPHEN = "-";
    jun.DOUBLE_QUOTE = '"';
    jun.BLANK = "";
    jun.ZERO = "0";
    jun.MINUS = "-";
    jun.HALF_SPACE = " ";
    jun.HTML_YEN = "&yen;";
    jun.TR = "tr";
    jun.CLASS_HIDE = "hide";
    jun.REGEXP_LOC = /JUN_APP_LOC/;
    jun.REGEXP_PNT_MLT = /point_(\d+)/;
    jun.REGEXP_TEL = /^([0-9]{10,20}|[0-9-]{10,20})$/;
    jun.LOC_FBZ = "JUN_APP_LOC_FBZ";
    jun.LOC_DST = "JUN_APP_LOC_DST";
    jun.TAG_RDC_TAX = "#軽減税率対象";
    jun.PRD_RSV_FLG = "TRUE";
    jun.PRD_NML_FLG = "FALSE";
    jun.PRD_GFT = "ギフト";
    jun.ATTR_GIFT_KEY = "ギフト希望";
    jun.ATTR_RSV_DELIV_DATE_KEY = "お届け予定日";
    jun.ATTR_GID_KEY = "gid";
    jun.ATTR_USE_POINT_KEY = "使用ポイント";
    jun.ATTR_CUSTOMER_RANK_KEY = "会員ランク";
    jun.ATTR_FAMILY_CODE_KEY = "社員コード";
    jun.ATTR_ESTIMATED_POINT = "獲得予定ポイント";
    jun.ATTR_COD_FEE = "代引手数料";
    jun.ATTR_TAX_INCLUDED_AMOUNT = "_tax_included_amount";
    jun.ATTR_CART_ID_KEY = "_cartId";
    jun.ATTR_LINES = "_lines";
    jun.GIFT_VAL_YES = "希望する";
    jun.CST_BLK = "ブラック";
    jun.TRANSACTION_CASH_ON_DELIV = "代金引換";
    jun.ERROR_CODE_ADDRESS_MISMATCH = "ZIP-001";
    jun.ERROR_CODE_INVENTORY_OVER = "INV-001";
    jun.ERROR_CODE_INVALID_TEL = "TEL-001";
    jun.TAX_RATE_NML = 0.1;
    jun.TAX_RATE_RDC = 0.08;
    jun.CASH_ON_DELIV_FREE = 11000;
    jun.CASH_ON_DELIV_FEE = 330;
    jun.ATTR_OUTLET_KEY = "価格タイプ";
    jun.ATTR_OUTLET_VAL = "アウトレット";
    jun.WHEEL_FROM_TIME = "2022-01-01 00:00:00"; // 20211221 JUN-752
    jun.WHEEL_TO_TIME = "2022-01-04 00:00:00"; // 20211221 JUN-752
    jun.SOCIAL_PLUS_VER2_START = "2040-12-31 00:00:00"; //JUN-773 20220318
    jun.SOCIAL_PLUS_2ND_START = "2040-12-31 00:00:00"; //JUN-773 20220329
    jun.POINT_USE_RATIO = 1; //JUN-861 20220519
    jun.POINT_VER2_START_TIME_STAGE = "2022-09-21 00:00:00"; //JUN-861 20220613
    jun.POINT_VER2_START_TIME = "2022-09-21 00:00:00"; //JUN-861 20220613
    //会員ランクポイント倍率リスト
    //JUN-861 20220609
    jun.CST_RANK_MLTI_LIST_VER1 = {
        diamond: 10,
        platinum: 5,
        gold: 3,
        silver: 2,
        regular: 1,
        temporary: 1,
    };
    jun.CST_RANK_MLTI_LIST = {
        diamond: 15,
        platinum: 10,
        gold: 5,
        silver: 3,
        regular: 2,
        temporary: 2,
    };
    //会員ランクの日本語リスト
    jun.CST_RANK_JP = {
        diamond: "ダイアモンド",
        platinum: "プラチナ",
        gold: "ゴールド",
        silver: "シルバー",
        regular: "レギュラー",
        temporary: "仮登録",
    };
    // お届け時間の選択肢
    jun.DELIV_TIME_CHOICES = [
        "指定なし",
        "午前中",
        "14:00～16:00",
        "16:00～18:00",
        "18:00～20:00",
        "19:00～21:00",
    ];
    // 決済方法
    jun.GATE_WAYS = {
        other: "その他",
        external_credit: "クレジットカード決済",
        cash_on_delivery: "代金引換",
        external_rakuten: "楽天ペイ",
        external_docomo: "d払い決済",
        external_amazon_pay: "AmazonPay",
        external_paypay: "PayPay",
        external_paidy: "Paidy",
    };
    // カート画面で一度に注文可能な商品個数上限
    jun.MAX_QUANTITY = 10;
    // 送料無料対象金額（税込）
    jun.FREE_SHIPPING_PRICE = 5500;
    jun.SHOPIFY_STOREFRONT_ACCESS_TOKEN = window.ENV_ACCESS_TOKEN;
    jun.CUSTOM_APP_URL = window.ENV_APP_URL;
    // backend（CUSTOM_APP_URL）の本人確認に失敗したときのエラーコード（ログインし直しが必要）
    jun.NOT_LOGGED_IN_ERROR_CODE = "AUT-005";
    jun.CMS_URL = window.ENV_CMS_URL;
    jun.FRONT_DOMAIN = window.ENV_FRONT_DOMAIN;
    jun.GATE_WAY_CASH_ON_DELIV = window.ENV_COD;
    // GIDサイト情報
    jun.GID_EDIT_KEY = "gid_edit_path";
    jun.GID_HISTORY_KEY = "gid_history_path";
    jun.GID_INFO_KEY = "gid_info_path";
    jun.GID_UNSUBSCRIBE_KEY = "gid_unsubscribe_path";
    jun.GID_INDEX_URL = "https://www.junglobal-id.com/";
    jun.ERROR_CODE_FAILED_TO_CONVERT_FROM_GID_TO_SHOPIFY = "VLD-003";
    jun.ERROR_CODE_FAILED_TO_EMAIL_HAS_ALREADY_BEEN_TAKEN = "FAT-002";
    jun.RANK_THRESHOLD_DATE = 5;
    jun.YAPPLI_BROWSER = "yappli"; //20211110 JUN-662
    jun.QUALICA_COOKIE_GID = "qualica_gid"; //20211110 JUN-662
    jun.JOL_AC_CAT_NAME_PROD = "jol_ac_cat"; //20211110 JUN-662
    jun.JOL_AC_CAT_NAME_STG = "jol_ac_cat_test"; //20211110 JUN-662
    jun.JOL_AC_COID_NAME_PROD = "jol_ac_coid"; //20211110 JUN-662
    jun.JOL_AC_COID_NAME_STG = "jol_ac_coid_test"; //20211110 JUN-662
    jun.STG_HOST_URL = "https://stg-app.junonline.jp"; //20211110 JUN-662
    jun.STG_CMS_URL = "https://www-s-test.junonline.jp"; //20211110 JUN-662
    jun.PROD_HOST_URL = "https://app.junonline.jp"; //20211110 JUN-662
    jun.PROD_CMS_URL = "https://www.junonline.jp"; //20211110 JUN-662
})(jun || (jun = {}));
var jun;
(function (jun) {
    var graphql;
    (function (graphql) {
        graphql.checkoutBase = `
      id
      appliedGiftCards {
        id
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
      }
      checkoutUrl
      cost {
        checkoutChargeAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
      }
      buyerIdentity {
        email
        phone
      }
      attributes {
        key
        value
      }
      lines(first: 110) {
        edges {
          node {
            id
            quantity
            discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
            }
            attributes {
              key
              value
            }
            merchandise {
              ... on ProductVariant {
                id
                sku
                title
                compareAtPrice {
                  amount
                }
                price {
                  amount
                }
                image {
                  id
                  src: originalSrc
                  altText
                }
                selectedOptions {
                  name
                  value
                }
                reserveFlg: metafield(
                  namespace: "reserve_flg"
                  key: "reserve_flg"
                ) {
                  value
                }
                reserveDeliveryDate: metafield(
                  namespace: "reserve_delivery_dt"
                  key: "reserve_delivery_date"
                ) {
                  value
                }
                originalPrice: metafield(
                  namespace: "original_price"
                  key: "original_price"
                ) {
                  value
                }
                systemData: metafield(namespace: "system", key: "system_data") {
                  value
                }
                colorName: metafield(namespace:"system", key:"color_name") {
                    value
                }
                purchase_limit: metafield(
                  namespace: "jun"
                  key: "purchase_limit"
                ) {
                  value
                }
                product {
                  id
                  handle
                  tags
                  title
                  productCode: metafield(
                    namespace: "system"
                    key: "product_code"
                  ) {
                    value
                  }
                  purchase_limit: metafield(
                    namespace: "jun"
                    key: "purchase_limit"
                  ) {
                    value
                  }
                }
              }
            }
          }
        }
      }
  `;
        graphql.queryCheckout = `
  query ($id:ID!) {
    node: cart(id: $id) {
    ${graphql.checkoutBase}
    }
  }
  `;
        graphql.checkoutCreate = `
  mutation cartCreate {
    cartCreate {
      cart {
        ${graphql.checkoutBase}
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
        graphql.queryProduct = `
        query ($codeQuery:String!) {
            products(first: 6, query: $codeQuery) {
                edges {
                    node {
                        id
                        title
                        tags
                        handle
                        vendor
                        productCode: metafield(namespace:"system", key:"product_code") {
                            value
                        }
                        variants (first: 1) {
                            edges {
                                node {
                                    id
                                    sku
                                    title
                                    price {
                                        amount
                                    }
                                    image {
                                        id
                                        src: originalSrc
                                        altText
                                    }
                                    originalPrice: metafield(namespace:"original_price", key:"original_price") {
                                        value
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    })(graphql = jun.graphql || (jun.graphql = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var tpl;
    (function (tpl) {
        /**
         * 最近見た商品・おすすめ商品・ギフト商品処理
         */
        function itemArea(recentItem, isGiftItem = false) {
            let firstVariant = recentItem.variants.edges[0].node;
            if (firstVariant.image == null) {
                return jun.BLANK;
            }
            let productUrl = "javascript:void(0);";
            const productCode = recentItem.productCode;
            if (productCode != null) {
                productUrl = jun.CMS_URL + "/products/d/" + productCode.value;
            }
            let html = `
         <li class="c-block-3__item">
           <a href="${productUrl}" class="c-block-3__link">
             <div class="c-block-3__img">
               <img src="${firstVariant.image.src}" alt="${firstVariant.image.altText}">
             </div>
     `;
            if (!isGiftItem) {
                const vendor = recentItem.vendor;
                const brand = vendor.substr(vendor.indexOf("＞") + 1);
                const brandName = brand.substr(brand.indexOf(":") + 1);
                html += `
             <p class="c-block-3__brand">${brandName}</p>
         `;
            }
            html += `
             <p class="c-block-3__name">${recentItem.title}</p>
             <p class="c-block-3__price">¥${jun.FormatUtil.amt(parseInt(firstVariant.price.amount))}</p>
     `;
            let originalPrice = firstVariant.originalPrice;
            if (originalPrice != null) {
                originalPrice = Number(firstVariant.originalPrice.value);
            }
            if (originalPrice && originalPrice != firstVariant.price.amount) {
                const percent = jun.FormatUtil.amt(Math.round((1 - firstVariant.price.amount / originalPrice) * 100));
                html += `
         <p class="c-block-3__off">${percent}%OFF</p>
     `;
            }
            html += `
           </a>
         </li>
     `;
            return html;
        }
        tpl.itemArea = itemArea;
    })(tpl = jun.tpl || (jun.tpl = {}));
})(jun || (jun = {}));
/// <reference path="../../library/jquery/index.d.ts" />
/// <reference path="../../library/jqueryui/index.d.ts" />
/// <reference path="./storefront.ts" />
/// <reference path="./const.ts" />
/// <reference path="./interface.ts" />
/// <reference path="./graphql.ts" />
/// <reference path="./tpl.ts" />
var jun;
(function (jun) {
    class AbstractApplication {
    }
    jun.AbstractApplication = AbstractApplication;
    async function ready(app) {
        TrackingUtil.appendImg({ debug_step: "ready-start" });
        app.display();
        //会員ランク表示
        HeaderMenuUtil.addCustomerRank();
        await jun.CheckoutUtil.initCheckoutData();
        // トラッキング用画像を追加
        TrackingUtil.appendImg({ debug_step: "ready-after-initCheckoutData" });
        //JUN-662 20211109
        let skipCtrl = false;
        readYappliCss();
        if (isYappli()) {
            let member_id = $("#tag-data-holder-common").data("gid");
            if (member_id == undefined || $.trim(member_id) == "") {
                const params = new URLSearchParams(window.location.search);
                const error_code = params.get("error_code");
                if (error_code != null && error_code != "") {
                    document.cookie = jun.QUALICA_COOKIE_GID + `=; max-age=0; path=/;`;
                }
                let jol_ac_cat_name = jun.JOL_AC_CAT_NAME_STG;
                if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                    jol_ac_cat_name = jun.JOL_AC_CAT_NAME_PROD;
                }
                let cookieArr = getCookieArray();
                let isloginQualicaGid = jun.QUALICA_COOKIE_GID in cookieArr; //開発環境の考慮
                if (jun.CUSTOM_APP_URL === jun.STG_HOST_URL ||
                    jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                    isloginQualicaGid =
                        jol_ac_cat_name in cookieArr && jun.QUALICA_COOKIE_GID in cookieArr;
                }
                if (isloginQualicaGid) {
                    jun.MaskUtil.addMask();
                    skipCtrl = true;
                    loginQualicaGid(cookieArr[jun.QUALICA_COOKIE_GID]);
                }
            }
        }
        //JUN-662 20211109
        if (!skipCtrl) {
            //checkoutに登録されている商品数を取得して表示
            jun.HeaderMenuUtil.addCartItems();
            //会員保持ポイント表示
            // api同時実行抑制
            const sleep = (time) => new Promise((r) => setTimeout(r, time));
            (async function () {
                for (let i = 0; i < 10; i++) {
                    if (jun.is_calling_api_point_get()) {
                        await sleep(100 * 2 ** i);
                        continue;
                    }
                    break;
                }
                HeaderMenuUtil.addHoldPoint();
            })();
            // 登録内容変更リンク作成
            HeaderMenuUtil.transGidEdit();
            app.init();
        }
        TrackingUtil.appendImg({ debug_step: "ready-end" });
    }
    jun.ready = ready;
    async function checkoutReady(app) {
        try {
            TrackingUtil.appendImg({ debug_step: "checkout-ready-start" });
            let dispResult = app.display(); //20211224 JUN-774
            TrackingUtil.appendImg({ debug_step: "checkout-ready-after-display" });
            await jun.CheckoutUtil.initCheckoutData();
            // トラッキング用画像を追加
            TrackingUtil.appendImg({
                debug_step: "checkout-ready-after-initCheckoutData",
            });
            //JUN-662 20211109
            readYappliCss();
            if (isYappli() && dispResult === undefined) {
                //20211224 JUN-774
                let member_id = $("#tag-data-holder-checkout-order").data("gid");
                if (member_id == undefined || $.trim(member_id) === "") {
                    const params = new URLSearchParams(window.location.search);
                    const error_code = params.get("error_code");
                    if (error_code != null && error_code != "") {
                        document.cookie = jun.QUALICA_COOKIE_GID + `=; max-age=0; path=/;`;
                    }
                    let jol_ac_cat_name = jun.JOL_AC_CAT_NAME_STG;
                    if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                        jol_ac_cat_name = jun.JOL_AC_CAT_NAME_PROD;
                    }
                    let cookieArr = getCookieArray();
                    let isloginQualicaGid = jun.QUALICA_COOKIE_GID in cookieArr; //開発環境の考慮
                    if (jun.CUSTOM_APP_URL === jun.STG_HOST_URL ||
                        jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                        isloginQualicaGid =
                            jol_ac_cat_name in cookieArr && jun.QUALICA_COOKIE_GID in cookieArr;
                    }
                    if (isloginQualicaGid) {
                        jun.MaskUtil.addMask();
                        loginQualicaGid(cookieArr[jun.QUALICA_COOKIE_GID]);
                    }
                }
            }
            app.init();
            TrackingUtil.appendImg({ debug_step: "checkout-ready-end-ok" });
        }
        catch (e) {
            TrackingUtil.appendImg({ debug_step: "checkout-ready-end-error" });
            // await Logger.error({
            //   message: e.name + ": " + e.message,
            // });
            // alert("予期せぬエラーが発生したので、TOP画面に戻ります。");
            // window.location.href = CMS_URL;
        }
    }
    jun.checkoutReady = checkoutReady;
    function isDefined(obj) {
        var type = $.type(obj);
        return type !== "null" && type !== "undefined";
    }
    jun.isDefined = isDefined;
    function isBoolean(obj) {
        return $.type(obj) === "boolean";
    }
    jun.isBoolean = isBoolean;
    function isNumber(obj) {
        return $.type(obj) === "number";
    }
    jun.isNumber = isNumber;
    function isString(obj) {
        return $.type(obj) === "string";
    }
    jun.isString = isString;
    function isEmpty(obj) {
        return jun.StringUtil.isEmpty(obj);
    }
    jun.isEmpty = isEmpty;
    function isObject(obj) {
        return $.isPlainObject(obj);
    }
    jun.isObject = isObject;
    function isArray(obj) {
        return $.type(obj) === "array";
    }
    jun.isArray = isArray;
    function isMobile() {
        return navigator.userAgent.match(/iPhone|Android.+Mobile/) !== null;
    }
    jun.isMobile = isMobile;
    /**
     * //JUN-861 20220519
     * checkoutに登録されている商品の税込合計金額を取得
     */
    function getTotalAmountLineItems() {
        const checkout = jun.CheckoutUtil.getCheckoutData();
        const lines = checkout.lines.edges;
        let total_amount = 0;
        for (const edge of lines) {
            const lineItem = edge.node;
            const linePrice = lineItem.merchandise.price.amount * lineItem.quantity;
            const taxRate = getCommonTaxRate(lineItem);
            total_amount += linePrice + linePrice * taxRate;
        }
        return (total_amount = Math.round(total_amount));
    }
    jun.getTotalAmountLineItems = getTotalAmountLineItems;
    /**
     * //JUN-861 20220519
     * 税率を取得
     */
    function getCommonTaxRate(lineItem) {
        const tags = lineItem.merchandise.product.tags;
        let taxRate;
        if ($.inArray(jun.TAG_RDC_TAX, tags) == -1) {
            taxRate = jun.TAX_RATE_NML;
        }
        else {
            taxRate = jun.TAX_RATE_RDC;
        }
        return taxRate;
    }
    jun.getCommonTaxRate = getCommonTaxRate;
    //JUN-796 20220530
    function isBase64(str) {
        if (str === "" || str.trim() === "") {
            return false;
        }
        try {
            return btoa(atob(str)) == str;
        }
        catch (err) {
            return false;
        }
    }
    jun.isBase64 = isBase64;
    //JUN-662 20211110
    //Yappliの判定
    function isYappli() {
        let browserName = jun.YAPPLI_BROWSER;
        let is_yappli = false;
        if ("userAgent" in navigator) {
            if (navigator.userAgent.toLowerCase().indexOf(browserName) !== -1) {
                is_yappli = true;
            }
        }
        else {
            if ("userAgentData" in navigator) {
                let brands = navigator.userAgentData.brands;
                for (let i = 0; i < brands.length; i++) {
                    if (brands[i]["brand"].toLowerCase().indexOf(browserName) !== -1) {
                        is_yappli = true;
                        break;
                    }
                }
            }
        }
        return is_yappli;
    }
    jun.isYappli = isYappli;
    //JUN-662 20211110
    //クッキー値の取得
    function getCookieArray() {
        let result = {};
        let cookies = document.cookie;
        let cookiesArray = cookies.split(";");
        for (let i = 0; i < cookiesArray.length; i++) {
            let cArray = $.trim(cookiesArray[i]).split("=");
            let cookieValue = "";
            for (let n = 1; n < cArray.length; n++) {
                if (n > 1) {
                    cookieValue += "=";
                }
                cookieValue += $.trim(cArray[n]);
            }
            result[$.trim(cArray[0])] = cookieValue;
        }
        return result;
    }
    jun.getCookieArray = getCookieArray;
    //JUN-662 20211110
    //Yappliログイン
    function loginQualicaGid(qualicaGid) {
        if (qualicaGid === undefined || qualicaGid === "") {
            return false;
        }
        let returnUrlAfterYappliLogin = null;
        const params = new URLSearchParams(window.location.search);
        returnUrlAfterYappliLogin = location.href;
        let form = document.createElement("form");
        const url = jun.CUSTOM_APP_URL + "/api/customer/yappli_login";
        form.method = "post";
        form.action = url;
        form.innerHTML = '<input name="qualicaGid" value=' + qualicaGid + ">";
        form.innerHTML +=
            '<input name="return_to" value=' + returnUrlAfterYappliLogin + ">";
        document.body.append(form);
        form.submit();
    }
    jun.loginQualicaGid = loginQualicaGid;
    //JUN-662 20211110
    //Yappli用のCSSの読み込み
    function readYappliCss() {
        if (isYappli()) {
            let css_links = document.getElementsByTagName("link");
            let target_links = [];
            let target_link = "";
            let target_vparams = [];
            let target_vparam = "";
            if (css_links.length > 0) {
                //cdnリンクを他タグから取得
                for (let i = 0; i < css_links.length; i++) {
                    if (css_links[i].href.indexOf("loader.css") !== -1) {
                        target_links = css_links[i].href.split("loader.css");
                        target_link = target_links[0].replace(/https:/g, "");
                        if (target_links[1].indexOf("=") !== -1) {
                            target_vparams = target_links[1].split("=");
                            target_vparam = target_vparams[1];
                        }
                        break;
                    }
                }
                if (target_vparam != "") {
                    target_vparam = "?ver=1.0.1";
                }
                let link = document.createElement("link");
                link.href = target_link + "yappli.css" + target_vparam;
                link.rel = "stylesheet";
                link.type = "text/css";
                link.media = "all";
                let header = document.getElementsByTagName("head")[0];
                header.appendChild(link);
                $("body").addClass("yappli");
            }
        }
    }
    jun.readYappliCss = readYappliCss;
    //JUN-662 20211110
    //checkout_idの取得
    function getCookieCheckOutId() {
        let checkout_id = "";
        let cookieArr = getCookieArray();
        let jol_ac_coid_name = jun.JOL_AC_COID_NAME_STG;
        if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
            jol_ac_coid_name = jun.JOL_AC_COID_NAME_PROD;
        }
        let jol_ac_coid_obj = {};
        if (jol_ac_coid_name in cookieArr) {
            if (cookieArr[jol_ac_coid_name] != "") {
                let jol_ac_coid_obj_str = decodeURIComponent(cookieArr[jol_ac_coid_name]);
                jol_ac_coid_obj = JSON.parse(jol_ac_coid_obj_str);
                checkout_id = jol_ac_coid_obj["id"];
            }
        }
        //空の場合リダイレクト
        if (checkout_id === "") {
            let create_checkout_id_url = jun.STG_CMS_URL + "/cart/generateback?return_to=";
            if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
                create_checkout_id_url = jun.PROD_CMS_URL + "/cart/generateback?return_to=";
            }
            window.location.href = create_checkout_id_url + location.href;
        }
        return checkout_id;
    }
    jun.getCookieCheckOutId = getCookieCheckOutId;
    /**
     * 20211221 JUN-752
     * 日本時間で現在日時のDateを返却
     * @returns
     */
    function getNowDateTime() {
        // 協定世界時の文字列を取得
        const date = new Date();
        const utc = date.toUTCString();
        // 取得された文字列の「GMT」を除去する
        const g_replace = utc.replace("GMT", "");
        // 除去された文字列を使用し、インスタンスする
        const gDate = new Date(g_replace);
        const hours = gDate.getHours();
        gDate.setHours(hours + 9);
        return gDate;
    }
    jun.getNowDateTime = getNowDateTime;
    /**
     * 20211221 JUN-752
     * 引き渡した時間の期間判定
     * @returns
     */
    function isBetWeenTerm(from_date_str, to_date_str) {
        from_date_str = from_date_str.replace(/[-]/g, "/");
        to_date_str = to_date_str.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        let to_date = new Date(to_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime() &&
            getNowDateTime().getTime() < to_date.getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.isBetWeenTerm = isBetWeenTerm;
    /**
     * 20220318 JUN-773
     * ソーシャルプラス洗い替え後の分岐
     * @returns
     */
    function get_social_plus_ver() {
        const from_date_str = jun.SOCIAL_PLUS_VER2_START.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return 2;
        }
        else {
            return 1;
        }
    }
    jun.get_social_plus_ver = get_social_plus_ver;
    /**
     * JUN-861 20220613
     * 1pt1円対応の分岐
     * @returns
     */
    function get_point_ver_2nd() {
        let from_date_str = jun.POINT_VER2_START_TIME_STAGE.replace(/[-]/g, "/");
        if (jun.CUSTOM_APP_URL === jun.PROD_HOST_URL) {
            from_date_str = jun.POINT_VER2_START_TIME.replace(/[-]/g, "/");
        }
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.get_point_ver_2nd = get_point_ver_2nd;
    /**
     * JUN-861 20220613
     * 1pt1円対応の分岐
     * @returns
     */
    function get_point_ratio() {
        if (get_point_ver_2nd()) {
            return jun.POINT_USE_RATIO;
        }
        else {
            return 2;
        }
    }
    jun.get_point_ratio = get_point_ratio;
    /**
     * 20220329 JUN-773
     * ソーシャルプラス2ndフェーズの分岐
     * @returns
     */
    function get_social_plus_ver_2nd() {
        const from_date_str = jun.SOCIAL_PLUS_2ND_START.replace(/[-]/g, "/");
        let from_date = new Date(from_date_str);
        if (from_date.getTime() <= getNowDateTime().getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    jun.get_social_plus_ver_2nd = get_social_plus_ver_2nd;
    /**
     * JUN-1186 20220916
     * @returns
     */
    function display_tracking_company_name(tracking_company_name) {
        if (tracking_company_name.indexOf("Japan Post") !== -1) {
            return "日本郵便";
        }
        else if (tracking_company_name.indexOf("Yamato") !== -1) {
            return "ヤマト運輸";
        }
        else {
            return tracking_company_name;
        }
    }
    jun.display_tracking_company_name = display_tracking_company_name;
    function is_calling_api_point_get() {
        const s = sessionStorage.getItem("calling_api_point_get");
        return s != null;
    }
    jun.is_calling_api_point_get = is_calling_api_point_get;
    function set_calling_api_point_get() {
        sessionStorage.setItem("calling_api_point_get", "calling");
    }
    jun.set_calling_api_point_get = set_calling_api_point_get;
    function remove_calling_api_point_get() {
        sessionStorage.removeItem("calling_api_point_get");
    }
    jun.remove_calling_api_point_get = remove_calling_api_point_get;
    class FetchUtil {
        constructor() {
            throw new Error("FetchUtilはnewできません。");
        }
        static async fetch(resource, init, success, goToCart = false, loadMask = true) {
            if (loadMask) {
                jun.MaskUtil.addMask();
            }
            const res = await fetch(resource, init);
            try {
                const data = await this.handleErrorPrepare(res);
                success(data);
            }
            catch (err) {
                goToCart ? this.goToCart(res) : this.onError(res);
            }
            finally {
                if (loadMask) {
                    jun.MaskUtil.removeMask();
                }
            }
        }
        static async handleErrorPrepare(res) {
            // 5xx系エラーのときにはエラー扱い
            if (res.status.toString().charAt(0) == "5") {
                throw new Error();
            }
            return res.json();
        }
        static onError(res) {
            if (!jun.isDefined(res)) {
                return;
            }
            const message = "予期せぬエラーが発生しました。しばらく時間をおいて再度お試しください。";
            alert(message);
            throw new Error(message);
        }
        static goToCart(res) {
            alert("予期せぬエラーが発生しました。カート画面に遷移します。");
            window.location.href = jun.CART_URL;
        }
    }
    jun.FetchUtil = FetchUtil;
    class StringUtil {
        constructor() {
            throw new Error("StringUtilはnewできません。");
        }
        static isEmpty(text) {
            if (!jun.isString(text) || text.length == 0) {
                return true;
            }
            return false;
        }
        static isNotEmpty(text) {
            return !jun.StringUtil.isEmpty(text);
        }
        static htmlEncode(text) {
            if (isEmpty(text))
                return jun.BLANK;
            var holders = this.htmlSpecialCharsPlaceHolders;
            for (var i = 0, len = holders.length; i < len; i++) {
                var holder = holders[i];
                var regexp = new RegExp(holder[0], "g");
                text = text.replace(regexp, holder[1]);
            }
            return text;
        }
        static htmlDecode(text) {
            if (isEmpty(text))
                return jun.BLANK;
            var holders = this.htmlSpecialCharsPlaceHolders;
            for (var i = holders.length - 1; 0 <= i; i--) {
                var holder = holders[i];
                var regexp = new RegExp(holder[1], "g");
                text = text.replace(regexp, holder[0]);
            }
            return text;
        }
        static nl2br(value) {
            if (isEmpty(value))
                return jun.BLANK;
            return value.replace(/\r?\n/g, "<br/>");
        }
        static singleByteCharacters(text) {
            let length = 0;
            for (var i = 0; i < text.length; i++) {
                var c = text.charCodeAt(i);
                if ((c >= 0x0 && c < 0x81) ||
                    c === 0xf8f0 ||
                    (c >= 0xff61 && c < 0xffa0) ||
                    (c >= 0xf8f1 && c < 0xf8f4)) {
                    length += 1;
                }
                else {
                    length += 2;
                }
            }
            return length;
        }
        /**
         * 対象文字列の「%d」を置換する
         */
        static replaceFormat(target, value) {
            return target.replace(new RegExp("%d"), value);
        }
        /**
         * nullかundefindならBLANKに変換する
         * @param val 対象文字列
         */
        static convertNullToBlank(val) {
            return val !== null && val !== undefined ? val : jun.BLANK;
        }
        /**
         * nullかundefindならBLANKに変換する
         * @param object 対象オブジェクト
         * @param convertTargetList 項目名のリスト
         */
        static convertNullToBlankObjectPart(object, convertTargetList) {
            for (let convertTarget of convertTargetList) {
                object[convertTarget] = this.convertNullToBlank(object[convertTarget]);
            }
        }
    }
    StringUtil.htmlSpecialCharsPlaceHolders = [
        ["&", "&amp;"],
        ["<", "&lt;"],
        [">", "&gt;"],
        ["\r", "&#13;"],
        ["\n", "&#10;"],
        ['"', "&quot;"],
        ["'", "&#39;"],
    ];
    jun.StringUtil = StringUtil;
    class FormatUtil {
        /**
         * 数値を整数に変換、数値以外はエラーを返却
         */
        static changeInteger(value) {
            if (!jun.isDefined(value)) {
                return jun.BLANK;
            }
            const num_value = Number(value);
            return String(Math.trunc(num_value));
        }
        /**
         * 全角を半角に変換
         */
        static is_hankaku_number(value) {
            if (value.match(/^[0-9]+$/)) {
                return true;
            }
            return false;
        }
        /**
         * 全角を半角に変換
         */
        static hankaku2Zenkaku(value) {
            return value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
            });
        }
        /**
         * 数値を金額形式（3桁カンマ区切り）に変換
         */
        static amt(value, mark = false) {
            if (!jun.isDefined(value)) {
                return jun.BLANK;
            }
            let ret = String(value).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            if (mark) {
                ret = "\xA5" + ret;
            }
            return ret;
        }
        /**
         * 金額形式（3桁カンマ区切り）を数値に変換
         */
        static amtDelSign(value) {
            if (jun.isEmpty(value)) {
                return null;
            }
            //円マークを除去
            value = $.trim(value).replace(/\xA5/g, jun.BLANK);
            return Number(value.replace(/,/g, jun.BLANK));
        }
        /**
         * 県コードを数値のみに変換
         */
        static getPrefId(value) {
            if (jun.isEmpty(value)) {
                return null;
            }
            const arr = value.split("-");
            if (!jun.isDefined(arr) || arr.length < 2) {
                return null;
            }
            return Number($.trim(arr[1]));
        }
        /**
         * string型の日付を変換して「YYYY年M月DD日 HH:MM」に変換
         */
        static getDateFormat(value, isHourAndTime = true) {
            const date = new Date(value);
            if (Number.isNaN(date.getFullYear())) {
                return jun.HYPHEN;
            }
            let ret = String(date.getFullYear()) +
                "年" +
                String(date.getMonth() + 1) +
                "月" +
                String(date.getDate()) +
                "日";
            if (isHourAndTime) {
                ret +=
                    jun.HALF_SPACE +
                        String(("0" + date.getHours()).slice(-2)) +
                        ":" +
                        String(("0" + date.getMinutes()).slice(-2));
            }
            return ret;
        }
        /**
         * string型の日付を変換して「YYYY年M月〇旬」に変換
         */
        static getDateFormat4Season(value) {
            let ret = jun.BLANK;
            const date = new Date(value);
            if (Number.isNaN(date.getFullYear())) {
                return ret;
            }
            const day = date.getDate();
            let season = jun.BLANK;
            switch (true) {
                case day <= 10:
                    season = "上旬";
                    break;
                case day <= 20:
                    season = "中旬";
                    break;
                default:
                    season = "下旬";
            }
            ret =
                String(date.getFullYear()) +
                    "年" +
                    String(date.getMonth() + 1) +
                    "月" +
                    season;
            return ret;
        }
    }
    jun.FormatUtil = FormatUtil;
    class MaskUtil {
        static addMask() {
            if (jun.MaskUtil.maskCount == 0) {
                $("body").addClass("loading");
            }
            jun.MaskUtil.maskCount++;
        }
        static removeMask() {
            if (jun.MaskUtil.maskCount == 0) {
                return;
            }
            jun.MaskUtil.maskCount--;
            if (jun.MaskUtil.maskCount == 0) {
                $("body").removeClass("loading");
            }
        }
    }
    MaskUtil.maskCount = 0;
    jun.MaskUtil = MaskUtil;
    class CheckoutUtil {
        static async initCheckoutData() {
            TrackingUtil.appendImg({ debug_step: "function-initCheckoutData-start" });
            //JUN-662 20211109
            let checkout_id = localStorage.getItem("checkout_id");
            if (checkout_id != null &&
                checkout_id.indexOf("gid://shopify/Cart/") !== 0) {
                checkout_id = "";
            }
            if (checkout_id != null && checkout_id != "") {
                await jun.CheckoutUtil.fetchCheckout(checkout_id);
                //注文完了済でなければ、処理を終了
                if (!jun.CheckoutUtil.isCompleted) {
                    TrackingUtil.appendImg({
                        debug_step: "function-initCheckoutData-end-ok",
                    });
                    return;
                }
            }
            // checkoutを作成
            TrackingUtil.appendImg({
                debug_step: "function-initCheckoutData-create-checkout-start",
            });
            await jun.CheckoutUtil.createCheckout();
            TrackingUtil.appendImg({
                debug_step: "function-initCheckoutData-create-checkout-end",
            });
        }
        //JUN-1149 22020914
        /**
         * checkoutをリフレッシュ
         */
        static async refreshCheckoutData() {
            const checkout_id = localStorage.getItem("checkout_id");
            if (checkout_id != null && checkout_id != "") {
                await jun.CheckoutUtil.fetchCheckout(checkout_id);
                return jun.CheckoutUtil.getCheckoutData();
            }
            return null;
        }
        //JUN-1149 22020914
        /**
         * checkoutからギフトカード情報を抜き出す
         */
        static getApplyGiftData(cart) {
            if (cart.appliedGiftCards[0] != undefined) {
                return cart.appliedGiftCards[0];
            }
            return null;
        }
        //JUN-1149 22020914
        /**
         * attributesの使用ポイントとチェックアウト情報のギフトカード金額の比較
         */
        static async isCheckUsePoint() {
            let checkout = await jun.CheckoutUtil.refreshCheckoutData();
            let giftCard = jun.CheckoutUtil.getApplyGiftData(checkout);
            let usePointValue = 0;
            let giftCardValue = 0;
            let usePoint = null;
            if (checkout.attributes != undefined) {
                usePoint = checkout.attributes.find((item) => {
                    return item.key === jun.ATTR_USE_POINT_KEY;
                });
                if (usePoint != null &&
                    usePoint != undefined &&
                    usePoint.value != undefined) {
                    usePointValue = Number(usePoint.value);
                }
            }
            if (giftCard !== null && giftCard.id != undefined && giftCard.id != "") {
                giftCardValue = Number(giftCard.balance.amount);
            }
            //console.log(usePointValue);
            //console.log(giftCardValue);
            if (usePointValue != giftCardValue) {
                return false;
            }
            return true;
        }
        static getCheckoutData() {
            const data = jun.CheckoutUtil.checkoutData;
            if (data == null) {
                throw new Error("先にinitCheckoutDataを行ってください。");
            }
            return data;
        }
        static setCheckoutData(cart) {
            if (cart == null) {
                throw new Error("データがありません。");
            }
            jun.CheckoutUtil.checkoutData = cart;
        }
        /**
         * checkoutをfetch
         * completedAtで注文済みかを確認
         */
        static async fetchCheckout(checkout_id) {
            const params = {
                query: jun.graphql.queryCheckout,
                variables: { id: checkout_id },
            };
            await jun.storefront.exeStoreFront(params, (obj) => {
                if (obj.errors) {
                    alert("予期せぬエラーが発生したのでカート画面に戻ります。");
                    location.href = jun.CMS_URL;
                    return;
                }
                const cart = obj.data.node;
                jun.CheckoutUtil.checkoutData = cart;
                jun.CheckoutUtil.isCompleted = cart == null;
            });
        }
        /**
         * checkoutを作成
         */
        static async createCheckout() {
            const params = {
                query: jun.graphql.checkoutCreate,
                variables: {},
            };
            let cart = null;
            while (this.retryIdleTime < 100) {
                //初回はsleepしない
                if (this.retryIdleTime != 1) {
                    await this.sleep(this.retryIdleTime);
                }
                await jun.storefront.exeStoreFront(params, (obj) => {
                    if (obj.errors) {
                        jun.CheckoutUtil.retryIdleTime *= 2;
                    }
                    else {
                        cart = obj.data.cartCreate.cart;
                    }
                });
                if (cart != null) {
                    break;
                }
            }
            if (cart == null || this.retryIdleTime > 100) {
                const message = "予期せぬエラーが発生しました。しばらく時間をおいて再度お試しください。";
                alert(message);
                throw new Error(message);
            }
            jun.CheckoutUtil.checkoutData = cart;
            localStorage.setItem("checkout_id", cart.id);
        }
        /**
         * checkoutに登録されている商品数を取得
         */
        static getCheckoutLineItems() {
            const cart = jun.CheckoutUtil.getCheckoutData();
            const lines = cart.lines.edges;
            let count = 0;
            for (const line of lines) {
                const quantity = line.node.quantity;
                count += quantity;
            }
            return count;
        }
        static hasReservedItem() {
            return jun.CheckoutUtil.getReservedItems().length > 0;
        }
        static getReservedItems() {
            const checkout = jun.CheckoutUtil.getCheckoutData();
            const lineItems = checkout.lineItems.edges;
            return lineItems.filter((item) => {
                return item.node.merchandise.reserveFlg !== "FALSE";
            });
        }
        static sleepEnd() {
            jun.MaskUtil.removeMask();
        }
        static async sleepStart(sec) {
            jun.MaskUtil.addMask();
            return new Promise((resolve) => setTimeout(resolve, sec * 1000));
        }
        static async sleep(sec) {
            await this.sleepStart(sec);
            this.sleepEnd();
        }
    }
    CheckoutUtil.checkoutData = null;
    CheckoutUtil.isCompleted = false;
    CheckoutUtil.retryIdleTime = 1;
    jun.CheckoutUtil = CheckoutUtil;
    class TagsUtil {
        static isGiftProduct(tags) {
            if (tags.length == 0) {
                return false;
            }
            return tags.includes(jun.PRD_GFT);
        }
        static isReduceTax(tags) {
            if (tags.length == 0) {
                return false;
            }
            return tags.includes(jun.TAG_RDC_TAX);
        }
        static getLocation(tags) {
            let ret = [];
            for (const tag of tags) {
                if (tag == jun.LOC_FBZ || tag == jun.LOC_DST) {
                    ret.push(tag);
                }
            }
            return ret;
        }
        static getCustomerRank(tags) {
            let ret = jun.BLANK;
            //JUN-861 20220613
            let cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST;
            if (!get_point_ver_2nd()) {
                cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST_VER1;
            }
            const rankList = Object.keys(cst_rank_mlti_list);
            for (const tag of tags) {
                for (const rank of rankList) {
                    if (tag == rank) {
                        ret = tag;
                        break;
                    }
                }
                if (ret != jun.BLANK) {
                    break;
                }
            }
            return ret;
        }
    }
    jun.TagsUtil = TagsUtil;
    class HeaderMenuUtil {
        static addCustomerRank() {
            const customerTags = $("[data-customerTags]").data("customerTags");
            if (customerTags == undefined) {
                return;
            }
            const customerRank = jun.TagsUtil.getCustomerRank(customerTags);
            const customerRankJp = jun.CST_RANK_JP[customerRank];
            $("[data-customer-rank]").text(customerRankJp);
            if (customerRank == "temporary") {
                $(".display_for_temporary").show();
            }
        }
        // 所持ポイントを表示
        static addHoldPoint() {
            jun.set_calling_api_point_get();
            const checkout = jun.CheckoutUtil.getCheckoutData();
            const shopifyCustomerId = $("[data-shopify-customer-id-for-header]").data("shopify-customer-id-for-header");
            if (shopifyCustomerId == undefined) {
                jun.remove_calling_api_point_get();
                return;
            }
            const init = {
                method: "get",
                mode: "cors",
                credentials: "include",
            };
            const param = "shopify_customer_id=" +
                shopifyCustomerId +
                "&checkout_id=" +
                checkout.id +
                "&shop_name=" +
                jun.FRONT_DOMAIN;
            const url = jun.CUSTOM_APP_URL + "/api/point/get?" + param;
            FetchUtil.fetch(url, init, (res) => {
                if (jun.isDefined(res.error.code)) {
                    if (res.error.code === jun.NOT_LOGGED_IN_ERROR_CODE) {
                        // 全ページで呼ばれるため alert は出さず、GID会員サイトへの遷移時に案内する
                        HeaderMenuUtil.notLoggedInMessage = res.error.message;
                    }
                    else {
                        alert(res.error.message);
                    }
                    jun.remove_calling_api_point_get();
                    return;
                }
                // 所持ポイント表示
                $("[data-hold-point]").text(jun.FormatUtil.amt(res.data.point));
                // ポイント有効期限表示
                const expireDate = res.data.expire_date;
                let expireString = jun.HYPHEN;
                if (expireDate != jun.BLANK) {
                    expireString =
                        expireDate.substr(0, 4) +
                            "/" +
                            Number(expireDate.substr(4, 2)) +
                            "/" +
                            Number(expireDate.substr(6, 2));
                }
                $("[data-point-expire]").text(expireString);
                jun.remove_calling_api_point_get();
            }, false, false);
        }
        /**
         * カート投入件数を表示
         */
        static addCartItems() {
            const count = jun.CheckoutUtil.getCheckoutLineItems();
            $("[data-cart-item-count]").text(count);
        }
        static transGidEdit() {
            $("[data-gidsite-change]").on("click", function () {
                HeaderMenuUtil.transGidSite(jun.GID_EDIT_KEY);
            });
        }
        /**
         * GID会員サイトへ遷移
         */
        static async transGidSite(gidPath) {
            // 本人確認に失敗済みなら、新しいタブを開く前にここで案内する
            // （タブを開いた後だと、裏に回った元のタブの alert が表示されないことがある）
            if (HeaderMenuUtil.notLoggedInMessage !== null) {
                alert(HeaderMenuUtil.notLoggedInMessage);
                location.href = "/account/login";
                return;
            }
            const gid = $("[data-gid-for-header]").data("gid-for-header");
            const init = {
                method: "get",
                mode: "cors",
                // backend はログイン時に発行した Cookie で本人確認する
                credentials: "include",
            };
            const param = "qualica_gid=" +
                gid +
                "&trans_path=" +
                gidPath +
                "&shop_name=" +
                jun.FRONT_DOMAIN;
            const url = jun.CUSTOM_APP_URL + "/api/transGidView?" + param;
            //ポップアップブロックを防ぐため、先にwindow.openする
            const newTab = window.open("", "_blank");
            await FetchUtil.fetch(url, init, (res) => {
                if (jun.isDefined(res.error.code)) {
                    if (newTab != null) {
                        newTab.close();
                    }
                    alert(res.error.message);
                    if (res.error.code === jun.NOT_LOGGED_IN_ERROR_CODE) {
                        location.href = "/account/login";
                    }
                    return;
                }
                const redirectPath = res.data.redirectPath;
                if (newTab != null) {
                    newTab.location.href = redirectPath;
                }
                // location.href = redirectPath;
                // window.open(redirectPath, '_blank');
            });
        }
    }
    // 所持ポイント取得（ページ読み込み時）で backend の本人確認に失敗したときのメッセージ。
    // GID会員サイトへの遷移前に見て、新しいタブを開かずにログインし直しを促す
    HeaderMenuUtil.notLoggedInMessage = null;
    jun.HeaderMenuUtil = HeaderMenuUtil;
    class ProductUtil {
        /**
         * 品番から商品を取得
         */
        static async getProductData(productCodeList) {
            if (productCodeList.length == 0) {
                return false;
            }
            let query = jun.BLANK;
            for (const code of productCodeList) {
                if (query == jun.BLANK) {
                    query = "tag:" + code;
                }
                else {
                    query += " OR tag:" + code;
                }
            }
            const params = {
                query: jun.graphql.queryProduct,
                variables: {
                    codeQuery: query,
                },
            };
            let resObj = false;
            await jun.storefront.exeStoreFront(params, (res) => {
                if (res.data.products.edges.length > 0) {
                    resObj = res.data.products.edges;
                }
            });
            return resObj;
        }
    }
    jun.ProductUtil = ProductUtil;
    class TrackingUtil {
        static resetWaitTime() {
            this.wait_time = 100;
        }
        static appendImg(query = {}) {
            return;
            const imgUrl = new URL(jun.CUSTOM_APP_URL + "/images/jun_app_tracking.png");
            Object.keys(query).forEach((name) => {
                imgUrl.searchParams.append(name, query[name]);
            });
            try {
                const checkout = jun.CheckoutUtil.getCheckoutData();
                imgUrl.searchParams.append("checkout_id", checkout.id);
            }
            catch (e) {
                imgUrl.searchParams.append("checkout_id", "no_id");
            }
            imgUrl.searchParams.append("ver", new Date().getTime().toString()); // キャッシュ対策
            const adminCheckoutId = $(".product-table").data("adminCheckoutId");
            if (adminCheckoutId != undefined) {
                imgUrl.searchParams.append("admin_checkout_id", adminCheckoutId);
            }
            imgUrl.searchParams.append("url", window.location.href);
            const content = '<img src="' +
                imgUrl.href +
                '" alt="tracking_jun_app" width="1" height="1">';
            setTimeout(function () {
                $("body").append(content);
            }, jun.TrackingUtil.wait_time);
            jun.TrackingUtil.wait_time += 100;
        }
    }
    TrackingUtil.wait_time = 100;
    jun.TrackingUtil = TrackingUtil;
    class Logger {
        static async info(extraParams = {}) {
            await this.post(extraParams, false);
        }
        static async error(extraParams = {}) {
            await this.post(extraParams, true);
        }
        static async post(extraParams, isError = true) {
            const init = {
                method: "post",
                mode: "cors",
                headers: Logger.getHeader(),
                body: JSON.stringify(Logger.getParams(extraParams, isError)),
            };
            await jun.FetchUtil.fetch(jun.CUSTOM_APP_URL + "/api/log", init, (res) => {
                var _a;
                if (jun.isDefined((_a = res.error) === null || _a === void 0 ? void 0 : _a.code)) {
                    return;
                }
            });
        }
        static getParams(extraParams, isError) {
            const context = {
                url: window.location.href,
                search: window.location.search,
                user_agent: window.navigator.userAgent.toLocaleLowerCase(),
            };
            return {
                is_error: isError,
                context: context,
                data: extraParams,
            };
        }
        static getHeader() {
            return {
                "Content-Type": "application/json",
                Accept: "application/json",
            };
        }
    }
    jun.Logger = Logger;
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart) {
        var graphql;
        (function (graphql) {
            graphql.cartLinesRemove = `
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ${jun.graphql.checkoutBase}
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
            graphql.cartLinesUpdate = `
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ${jun.graphql.checkoutBase}
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
            graphql.cartLinesUpdateLight = `
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        id
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
            graphql.cartAttributesUpdate = `
  mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      cart {
        id
        checkoutUrl
      }
      userErrors {
        field
        message
      }
    }
  }
  `;
        })(graphql = cart.graphql || (cart.graphql = {}));
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart_1) {
        class CartItem {
            constructor(el) {
                // クラス内での追加element
                this.extendEl = {
                    checkoutInfo: "[data-checkout-info-area]",
                    lineItemPrice: "[data-line-item-price]",
                    lineItemPriceTotal: "[data-line-item-price-total]",
                    lineItemsSubtotal: "[data-line-items-subtotal]",
                    lineItemsTaxNmlTotal: "[data-line-items-taxnml-total]",
                    lineItemsTaxRdcTotal: "[data-line-items-taxrdc-total]",
                    lineItemsTotal: "[data-line-items-total]",
                    giftOrderArea: "[data-gift-order-area]",
                    checkedGiftOrderRadio: "[name=gift-order]:checked",
                    giftOrderRadio: "[data-gift-order]",
                    noGiftOrderRadio: "[data-no-gift-order]",
                    dataCartItem: "[data-cart-item]",
                    lineItemsShipping: "[data-line-items-shipping]",
                    loginLink: "[data-login-link]",
                    familyCodeInput: "[data-family-code-input]",
                };
                this.el = $.extend(el, this.extendEl);
            }
            /**
             * 保持しているcheckoutをカート表示エリアに追加
             */
            addCartArea() {
                const me = this;
                const cartEl = me.el;
                const cart = jun.CheckoutUtil.getCheckoutData();
                const linesEdges = cart.lines.edges;
                const Point = new jun.cart.Point(cartEl);
                if (linesEdges.length == 0) {
                    $(cartEl.cartContent).addClass(jun.CLASS_HIDE);
                    $(cartEl.cartEmptyContent).removeClass(jun.CLASS_HIDE);
                    return;
                }
                let $lines = [];
                let is_none_checkout_flg = false;
                for (const edge of linesEdges) {
                    const lineItem = edge.node;
                    if (lineItem.merchandise == undefined) {
                        is_none_checkout_flg = true;
                        break;
                    }
                    const tag = lineItem.merchandise.product.tags;
                    const pointTimes = Point.getPointMultiple(tag);
                    const $row = $(jun.cart.tpl.lineItem(cartEl, lineItem, pointTimes));
                    $lines.push($row);
                }
                if (is_none_checkout_flg) {
                    window.localStorage.removeItem("checkout_id");
                    return;
                }
                me.presetFamilyCode();
                me.dispGiftControl(cart);
                $(cartEl.lineItems).append($lines);
                const subTotal = Number(cart.cost.subtotalAmount.amount);
                me.addSubTotalPrice(linesEdges, subTotal);
                $(cartEl.cartContent).removeClass(jun.CLASS_HIDE);
            }
            presetFamilyCode() {
                const cart = jun.CheckoutUtil.getCheckoutData();
                const familyCode = cart.attributes.find((item) => {
                    return item.key === jun.ATTR_FAMILY_CODE_KEY;
                });
                if (!familyCode) {
                    return;
                }
                $(this.el.familyCodeInput).val(familyCode.value);
            }
            /**
             * チェックアウト画面遷移時イベント
             */
            async tranCheckout(event) {
                const me = event.data;
                const transitVal = $(this).data("transit");
                const cart = jun.CheckoutUtil.getCheckoutData();
                const lineItemsEdges = cart.lines.edges;
                //JUN-732 20211130
                //ギフト商品が存在しない場合は希望しないに強制する
                if (!me.hasGiftProduct(lineItemsEdges)) {
                    $(me.el.noGiftOrderRadio).prop("checked", true);
                }
                //ブラック会員チェック、購入商品数上限チェック、ギフト商品・予約商品同梱チェック
                if (me.blackCheck() ||
                    me.skuCntCheck(lineItemsEdges) ||
                    me.giftCheck(lineItemsEdges)) {
                    return;
                }
                // 残高の確認はポイント適用時の1回だけのため、適用後に残高が減ると
                // 出荷指示時のポイント減算が失敗する。遷移前に確認し直す
                if (await me.releasePointIfShort(cart)) {
                    return;
                }
                await me.updateLineItemAttributes();
                // gidはuserData(非同期取得)由来、使用ポイントはcart.appliedGiftCards(同期)由来のため、
                // userData未取得のままチェックアウトするとgidだけ欠落した注文になる。
                // (ポイント適用直後のlocation.reload()でuserDataがnullに戻るため発生しやすい)
                // ポイント適用済みでgidが未解決の場合のみ、userDataの到着を待つ。
                // 待っても取得できない場合はそのまま進める(backend側のフォールバックに委ねる)
                if (cart.appliedGiftCards.length > 0 &&
                    !jun.cart.Application.userData &&
                    !cart.attributes.some((attr) => attr.key == jun.ATTR_GID_KEY)) {
                    const sleep = (time) => new Promise((r) => setTimeout(r, time));
                    for (let i = 0; i < 40; i++) {
                        if (jun.cart.Application.userData) {
                            break;
                        }
                        await sleep(500);
                    }
                }
                const newAttributes = me.makeNewAttributes(cart);
                const params = {
                    query: jun.cart.graphql.cartAttributesUpdate,
                    variables: {
                        cartId: cart.id,
                        attributes: newAttributes,
                    },
                };
                jun.storefront.exeStoreFront(params, (res) => {
                    const resObj = res.data.cartAttributesUpdate;
                    if (resObj.userErrors.length > 0) {
                        alert("予期せぬエラーが発生しました。しばらく間をあけて再度お試しください。");
                        return;
                    }
                    let url = resObj.cart.checkoutUrl;
                    if (transitVal == "login") {
                        url =
                            jun.HOST_URL +
                                "/account/login?view=cart&checkout_url=" +
                                encodeURIComponent(url);
                    }
                    window.location.href = url;
                });
            }
            /**
             * 適用中のポイントが残高不足・期限切れなら適用を解除する
             * @returns 解除した場合 true
             */
            async releasePointIfShort(cart) {
                var _a;
                const me = this;
                const $customerId = $(me.el.shopifyCustomerId);
                if (cart.appliedGiftCards.length == 0 || $customerId.length == 0) {
                    return false;
                }
                const customApp = new jun.cart.CustomApp(me.el);
                jun.MaskUtil.addMask();
                // 取り直せなければ、ページ表示時に取得済みの値で判定する
                const userData = (_a = (await customApp.refreshCustomerData($customerId.data("shopify-customer-id"), cart_1.POINT_RECHECK_TIMEOUT))) !== null && _a !== void 0 ? _a : jun.cart.Application.userData;
                jun.MaskUtil.removeMask();
                // 残高が分からないときは通す(出荷指示側で失敗しうるが、売上を失うよりよい)
                if (!userData) {
                    return false;
                }
                const giftCard = cart.appliedGiftCards[0];
                const giftAmount = Number(giftCard.amountUsed.amount) + Number(giftCard.balance.amount);
                if (userData.point * jun.get_point_ratio() >= giftAmount &&
                    !me.isPointExpired(userData.expire_date)) {
                    return false;
                }
                alert("ご利用可能なポイントが変更されたため、ポイントの適用を解除しました。\nお手数ですが、ポイントを再度ご指定ください。");
                await customApp.requestStopToUsePoint();
                location.reload();
                return true;
            }
            /**
             * ポイント有効期限切れかどうか(backendのcheckBeforeUsePointと同じ基準)
             * @param expireDate YYYYMMDD。未設定は期限切れ扱い
             */
            isPointExpired(expireDate) {
                if (!expireDate) {
                    return true;
                }
                const end = new Date(Number(expireDate.slice(0, 4)), Number(expireDate.slice(4, 6)) - 1, Number(expireDate.slice(6, 8)), 23, 59, 59);
                return end.getTime() < Date.now();
            }
            /**
             * JUN-732 20211130
             * ギフト商品存在チェック
             */
            hasGiftProduct(lineItemsEdges) {
                let ret = false;
                for (const edge of lineItemsEdges) {
                    const lineItem = edge.node;
                    const isGift = jun.TagsUtil.isGiftProduct(lineItem.merchandise.product.tags);
                    if (isGift) {
                        ret = true;
                        break;
                    }
                }
                return ret;
            }
            /**
             * ブラック会員かどうかをチェック
             */
            blackCheck() {
                const me = this;
                const customerTags = $(me.el.customerTags).data("customerTags");
                if (!jun.isDefined(customerTags)) {
                    return false;
                }
                const ret = customerTags.includes(jun.CST_BLK);
                if (ret) {
                    alert("購入が拒否されました。");
                }
                return ret;
            }
            /**
             * 購入商品数上限チェック
             */
            skuCntCheck(lineItemsEdges) {
                const ret = lineItemsEdges > 100;
                if (ret) {
                    alert("購入商品数上限を超えています。");
                }
                return ret;
            }
            /**
             * ギフト商品・予約商品同梱チェック
             */
            giftCheck(lineItemsEdges) {
                let isGiftWrapping = $(this.el.checkedGiftOrderRadio).val() == jun.GIFT_VAL_YES;
                let isExistRsv = false;
                //ギフト商品＆予約商品同時投入チェック
                for (const edge of lineItemsEdges) {
                    const lineItem = edge.node;
                    if (!isExistRsv) {
                        let reserveFlg = jun.PRD_NML_FLG;
                        if (lineItem.merchandise.reserveFlg != undefined &&
                            lineItem.merchandise.reserveFlg.value != "") {
                            reserveFlg = lineItem.merchandise.reserveFlg.value;
                        }
                        isExistRsv = reserveFlg == jun.PRD_RSV_FLG;
                    }
                }
                const ret = isExistRsv && isGiftWrapping;
                if (ret) {
                    alert("予約商品が含まれているため、ギフトラッピング受付はできません。");
                }
                return ret;
            }
            getLines(cart) {
                const lineItems = cart.lines.edges;
                const lines = [];
                for (const edge of lineItems) {
                    const node = edge.node;
                    lines.push({
                        id: node.id,
                        quantity: node.quantity,
                        variants_id: node.merchandise.id,
                        sku: node.merchandise.sku,
                        price: parseInt(node.merchandise.price.amount),
                        reserve_flg: node.merchandise.reserveFlg.value,
                        product_id: node.merchandise.product.id,
                        product_tags: node.merchandise.product.tags,
                    });
                }
                return lines;
            }
            /**
             * attribute再作成処理
             */
            makeNewAttributes(cart) {
                const me = this;
                const oldAttributes = cart.attributes;
                let newAttributes = [];
                for (const attr of oldAttributes) {
                    if (attr.key != jun.ATTR_GIFT_KEY &&
                        attr.key != jun.ATTR_GID_KEY &&
                        attr.key != jun.ATTR_USE_POINT_KEY &&
                        attr.key != jun.ATTR_CUSTOMER_RANK_KEY &&
                        attr.key != jun.ATTR_FAMILY_CODE_KEY &&
                        attr.key != jun.ATTR_ESTIMATED_POINT &&
                        attr.key != jun.ATTR_COD_FEE &&
                        attr.key != jun.ATTR_TAX_INCLUDED_AMOUNT &&
                        attr.key != jun.ATTR_CART_ID_KEY &&
                        attr.key != jun.ATTR_LINES) {
                        newAttributes.push(attr);
                    }
                }
                //ギフト注文かどうか
                newAttributes.push({
                    key: jun.ATTR_GIFT_KEY,
                    value: $(me.el.checkedGiftOrderRadio).val(),
                });
                const userData = jun.cart.Application.userData;
                if (userData) {
                    //GID
                    newAttributes.push({
                        key: jun.ATTR_GID_KEY,
                        value: userData.qualica_gid,
                    });
                }
                else if ($(me.el.shopifyCustomerId).length > 0) {
                    // ログイン中でuserData未取得(非同期取得待ち)の場合のみ、gid属性を消さず既存値を引き継ぐ
                    // (未ログイン時はここを通さず、古いgidを残さないようにする)
                    const oldGidAttr = oldAttributes.find((attr) => attr.key == jun.ATTR_GID_KEY);
                    if (oldGidAttr) {
                        newAttributes.push(oldGidAttr);
                    }
                }
                //20210112 JUN-795
                if (cart.appliedGiftCards.length > 0) {
                    const giftCard = cart.appliedGiftCards[0];
                    let giftAmount = Number(giftCard.amountUsed.amount);
                    // let giftBalance: number = Number(giftCard.balance.amount); //使用前のギフト残額、注文が完了するまで作成時のギフト残額となる
                    // giftAmount = giftBalance;
                    newAttributes.push({
                        key: jun.ATTR_USE_POINT_KEY,
                        value: String(giftAmount),
                    });
                }
                //カスタマーランク
                const customerTags = $(me.el.customerTags).data("customerTags");
                if (customerTags != undefined) {
                    newAttributes.push({
                        key: jun.ATTR_CUSTOMER_RANK_KEY,
                        value: jun.TagsUtil.getCustomerRank(customerTags),
                    });
                }
                //社員コード
                const familyCode = $(me.el.familyCodeInput).val();
                if (familyCode) {
                    newAttributes.push({
                        key: jun.ATTR_FAMILY_CODE_KEY,
                        value: familyCode,
                    });
                }
                const point = new jun.cart.Point(me.el);
                const calcPoint = point.calcPoint();
                newAttributes.push({
                    key: jun.ATTR_ESTIMATED_POINT,
                    value: calcPoint.toString(),
                });
                newAttributes.push({
                    key: jun.ATTR_TAX_INCLUDED_AMOUNT,
                    value: jun.getTotalAmountLineItems().toString(),
                });
                const cart_id = localStorage.getItem("checkout_id");
                if (cart_id != null) {
                    newAttributes.push({
                        key: jun.ATTR_CART_ID_KEY,
                        value: cart_id,
                    });
                }
                newAttributes.push({
                    key: jun.ATTR_LINES,
                    value: JSON.stringify(this.getLines(cart)),
                });
                return newAttributes;
            }
            /**
             * lineitemのAttributeを更新する処理
             */
            async updateLineItemAttributes() {
                const cart = jun.CheckoutUtil.getCheckoutData();
                const lineItemsEdges = cart.lines.edges;
                let updateLineItems = [];
                for (const edge of lineItemsEdges) {
                    const lineItem = edge.node;
                    let attributes = lineItem.attributes.filter((item) => {
                        return (item.key !== jun.ATTR_FAMILY_CODE_KEY &&
                            item.key !== jun.ATTR_GIFT_KEY &&
                            item.key !== jun.ATTR_RSV_DELIV_DATE_KEY);
                    });
                    const familyCode = $(this.el.familyCodeInput).val();
                    if (familyCode) {
                        attributes.push({
                            key: jun.ATTR_FAMILY_CODE_KEY,
                            value: familyCode,
                        });
                    }
                    const isGift = jun.TagsUtil.isGiftProduct(lineItem.merchandise.product.tags);
                    if (isGift) {
                        attributes.push({
                            key: jun.ATTR_GIFT_KEY,
                            value: $(this.el.checkedGiftOrderRadio).val(),
                        });
                    }
                    let reserveFlg = jun.PRD_NML_FLG;
                    if (lineItem.merchandise.reserveFlg != undefined &&
                        lineItem.merchandise.reserveFlg.value != "") {
                        reserveFlg = lineItem.merchandise.reserveFlg.value;
                    }
                    if (reserveFlg == jun.PRD_RSV_FLG) {
                        const reserveDeliveryDate = lineItem.merchandise.reserveDeliveryDate;
                        let dateStr = "未設定";
                        if (reserveDeliveryDate != null &&
                            reserveDeliveryDate.value != jun.BLANK) {
                            dateStr = reserveDeliveryDate.value;
                        }
                        attributes.push({
                            key: jun.ATTR_RSV_DELIV_DATE_KEY,
                            value: dateStr,
                        });
                    }
                    /*
                    let is_outlet_product: boolean = jun.TagsUtil.isOutletProduct(
                      lineItem.merchandise.product.tags
                    );
                    if (is_outlet_product) {
                      attributes.push({
                        key: ATTR_OUTLET_KEY,
                        value: ATTR_OUTLET_VAL,
                      });
                    }
                     */
                    let updateLineItem = {
                        id: lineItem.id,
                        attributes: attributes,
                    };
                    updateLineItems.push(updateLineItem);
                }
                const params = {
                    query: jun.cart.graphql.cartLinesUpdateLight,
                    variables: {
                        cartId: cart.id,
                        lines: updateLineItems,
                    },
                };
                await jun.storefront.exeStoreFront(params, (res) => {
                    // do nothing
                });
            }
            /**
             * 商品削除ボタン押下時イベント
             */
            removeLineItem(event) {
                const me = event.data;
                const $targetRow = $(this).closest(me.el.dataCartItem);
                $targetRow.find("input").prop("disabled", true);
                const cart = jun.CheckoutUtil.getCheckoutData();
                const params = {
                    query: jun.cart.graphql.cartLinesRemove,
                    variables: {
                        cartId: cart.id,
                        lineIds: [$targetRow.data("lineItemId")],
                    },
                };
                jun.storefront.exeStoreFront(params, (res) => {
                    const resObj = res.data.cartLinesRemove;
                    if (resObj.userErrors.length > 0) {
                        alert("予期せぬエラーが発生しました。しばらく間をあけて再度お試しください。");
                        return;
                    }
                    me.saveLineItems(resObj.cart);
                    $targetRow.remove();
                });
            }
            /**
             * 商品数量変更時イベント
             */
            updateLineItem(event) {
                const me = event.data;
                const $targetRow = $(this).closest(me.el.dataCartItem);
                const cart = jun.CheckoutUtil.getCheckoutData();
                const params = {
                    query: jun.cart.graphql.cartLinesUpdate,
                    variables: {
                        cartId: cart.id,
                        lines: [
                            {
                                quantity: Number($(this).val()),
                                id: $(this).data("productId"),
                            },
                        ],
                    },
                };
                jun.storefront.exeStoreFront(params, (res) => {
                    const resObj = res.data.cartLinesUpdate;
                    if (resObj.userErrors.length > 0) {
                        alert("予期せぬエラーが発生しました。しばらく間をあけて再度お試しください。");
                        return;
                    }
                    const isCartHide = me.saveLineItems(resObj.cart);
                    if (!isCartHide) {
                        // 金額再計算
                        const unitPrice = jun.FormatUtil.amtDelSign($targetRow.find(me.el.lineItemPrice).text()) || 0;
                        const quantity = Number($targetRow.find(me.el.productQuantity).val());
                        $targetRow
                            .find(me.el.lineItemPriceTotal)
                            .text(jun.FormatUtil.amt(unitPrice * quantity));
                        // 数量0の時、行削除
                        if (quantity == 0) {
                            $targetRow.remove();
                        }
                    }
                });
                // メニューのカート投入数を更新
                jun.HeaderMenuUtil.addCartItems();
            }
            /**
             * 商品削除・数量変更後処理
             */
            saveLineItems(cart) {
                const me = this;
                const el = me.el;
                jun.CheckoutUtil.setCheckoutData(cart);
                //チェックアウト内に商品が存在するか
                const isCartHide = cart.lines.edges.length == 0;
                if (isCartHide) {
                    //カート内空画面表示
                    $(el.cartContent).addClass(jun.CLASS_HIDE);
                    $(el.cartEmptyContent).removeClass(jun.CLASS_HIDE);
                }
                else {
                    me.dispGiftControl(cart);
                    const Point = new jun.cart.Point(me.el);
                    Point.pointControl(cart);
                    const lineItems = cart.lines.edges;
                    const subTotal = Number(cart.cost.subtotalAmount.amount);
                    me.addSubTotalPrice(lineItems, subTotal);
                }
                // メニューのカート投入数を更新
                jun.HeaderMenuUtil.addCartItems();
                return isCartHide;
            }
            /**
             * 注文合計・消費税等を表示
             */
            addSubTotalPrice(lineItems, subTotal) {
                const me = this;
                const cartEl = me.el;
                let total = 0;
                let taxNmlTotal = 0;
                let taxRdcTotal = 0;
                for (const edge of lineItems) {
                    const lineItem = edge.node;
                    const linePrice = lineItem.merchandise.price.amount * lineItem.quantity;
                    const taxRate = me.getTaxRate(lineItem);
                    if (taxRate == jun.TAX_RATE_NML) {
                        taxNmlTotal += linePrice * taxRate;
                    }
                    else if (taxRate == jun.TAX_RATE_RDC) {
                        taxRdcTotal += linePrice * taxRate;
                    }
                    total += linePrice + linePrice * taxRate;
                }
                const shipping = me.getFreeShippingMore(total);
                const point = new jun.cart.Point(me.el);
                const calcPoint = point.calcPoint();
                const customerId = $(cartEl.shopifyCustomerId).data("shopify-customer-id");
                const params = {
                    total: total,
                    subTotal: subTotal,
                    taxNmlTotal: taxNmlTotal,
                    taxRdcTotal: taxRdcTotal,
                    calcPoint: calcPoint,
                    shipping: shipping,
                    customerId: customerId,
                };
                const subTotalPrice = $(jun.cart.tpl.subTotalPrice(params));
                $(cartEl.checkoutInfo).html("");
                $(cartEl.checkoutInfo).prepend(subTotalPrice);
            }
            /**
             * 税率を取得
             */
            getTaxRate(lineItem) {
                const tags = lineItem.merchandise.product.tags;
                let taxRate;
                if ($.inArray(jun.TAG_RDC_TAX, tags) == -1) {
                    taxRate = jun.TAX_RATE_NML;
                }
                else {
                    taxRate = jun.TAX_RATE_RDC;
                }
                return taxRate;
            }
            /**
             * 配送無料までの残金を取得
             */
            getFreeShippingMore(total) {
                const me = this;
                if ($(me.el.cartContent).data("freeDelivery") === true) {
                    return 0;
                }
                const customerTags = $(me.el.customerTags).data("customerTags");
                if (customerTags != undefined) {
                    const custmerRank = jun.TagsUtil.getCustomerRank(customerTags);
                    //JUN-861 20220613
                    let cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST;
                    if (!jun.get_point_ver_2nd()) {
                        cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST_VER1;
                    }
                    const customerRankMultiple = cst_rank_mlti_list[custmerRank];
                    // ゴールドランク以上の場合、送料無料
                    if (customerRankMultiple >= 5) {
                        return 0;
                    }
                }
                return 1; // ECPF-1276 送料無料条件変更
            }
            /**
             * ギフトラジオボタン表示非表示処理
             */
            dispGiftControl(cart) {
                const me = this;
                const lineItemsEdges = cart.lines.edges;
                let isExistGift = false;
                for (const edge of lineItemsEdges) {
                    const lineItem = edge.node;
                    if (!isExistGift) {
                        isExistGift = jun.TagsUtil.isGiftProduct(lineItem.merchandise.product.tags);
                    }
                }
                const $giftArea = $(me.el.giftOrderArea);
                if (isExistGift) {
                    $giftArea.removeClass(jun.CLASS_HIDE);
                }
                else if (!$giftArea.hasClass(jun.CLASS_HIDE)) {
                    $giftArea.addClass(jun.CLASS_HIDE);
                }
                const attributes = cart.attributes;
                for (const attr of attributes) {
                    if (attr.key == jun.ATTR_GIFT_KEY) {
                        $(me.el.giftOrderRadio).prop("checked", attr.value == jun.GIFT_VAL_YES);
                        break;
                    }
                }
                if ($(me.el.checkedGiftOrderRadio).length == 0) {
                    $(me.el.noGiftOrderRadio).prop("checked", true);
                }
            }
            /**
             * 商品タグから出荷元の数を取得
             */
            /*
            private getShipperMultiple(tags: any) {
              let matchFBZ = 0;
              let matchDST = 0;
              for (const tag of tags) {
                if (tag.match(jun.LOC_FBZ) !== null) {
                  matchFBZ += 1;
                }
                if (tag.match(jun.LOC_DST) !== null) {
                  matchDST += 1;
                }
              }
              return matchFBZ + matchDST;
            }
             */
            /**
             * ログインリンクを作成
             */
            addLoginLink() {
                const me = this;
                const cartEl = me.el;
                const link = "/account/login?cart_url=" + encodeURIComponent(location.href);
                $(cartEl.loginLink).attr("href", link);
            }
        }
        cart_1.CartItem = CartItem;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart_2) {
        class Point {
            constructor(el) {
                // クラス内での追加element
                this.extendEl = {
                    availablePointArea: "[data-available-point]",
                    customerPointArea: "[data-customer-point-area]",
                    customerPointAreaUnavailable: "[data-customer-point-area-unavailable]",
                };
                this.el = $.extend(el, this.extendEl);
            }
            //取得予定ポイントを計算
            calcPoint() {
                const me = this;
                const object4Point = me.getObject4Point();
                //使用ポイント残額
                let usePointAmountLeft = object4Point.usePointAmount;
                let totalGetPoint = 0;
                for (const lineItem of object4Point.lineItem4Point) {
                    let lineItemTotalAmount = lineItem.price * lineItem.quantity - lineItem.discount;
                    //使用ポイント残額がある場合
                    if (usePointAmountLeft != 0) {
                        //該当商品のトータル金額より使用ポイント残額が低い場合
                        if (lineItemTotalAmount > usePointAmountLeft) {
                            lineItemTotalAmount -= usePointAmountLeft;
                            usePointAmountLeft = 0;
                            //該当商品のトータル金額より使用ポイント残額が高いまたは同額の場合
                        }
                        else {
                            usePointAmountLeft -= lineItemTotalAmount;
                            lineItemTotalAmount = 0;
                        }
                    }
                    const getPointBase = Math.floor(lineItemTotalAmount * 0.01);
                    totalGetPoint +=
                        getPointBase *
                            me.calcPointRank(lineItem, object4Point.customerRankMultiple);
                }
                return totalGetPoint;
            }
            //該当商品の配列を作成
            getObject4Point() {
                const me = this;
                const cart = jun.CheckoutUtil.getCheckoutData();
                let lineItems4Point = [];
                for (const edge of cart.lines.edges) {
                    const lineItem = edge.node;
                    //現在値と元値
                    const price = Number(lineItem.merchandise.price.amount);
                    let discount = 0;
                    //ディスカウント使用時は保持
                    if (lineItem.discountAllocations.length > 0) {
                        discount = Number(lineItem.discountAllocations[0].discountedAmount.amount);
                    }
                    const originalPrice = Number(lineItem.merchandise.originalPrice.value);
                    lineItems4Point.push({
                        //現在値と元値から割引率を算出し、sale商品かどうかを判断
                        //JUN-965 20220921
                        //"saleFlg": ((1 - (price / originalPrice)) * 100) >= 20,
                        saleFlg: price < originalPrice,
                        //ポイント倍率キャンペーン考慮
                        pointMultiple: me.getPointMultiple(lineItem.merchandise.product.tags),
                        price: price,
                        quantity: lineItem.quantity,
                        discount: discount,
                    });
                }
                //ポイント倍率順に配列を並べ替え
                const customerTags = $(me.el.customerTags).data("customerTags");
                let customerRankMultiple;
                //JUN-861 20220613
                let cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST;
                if (!jun.get_point_ver_2nd()) {
                    cst_rank_mlti_list = jun.CST_RANK_MLTI_LIST_VER1;
                }
                if (customerTags != undefined) {
                    const custmerRank = jun.TagsUtil.getCustomerRank(customerTags);
                    customerRankMultiple = cst_rank_mlti_list[custmerRank];
                }
                else {
                    customerRankMultiple = 1;
                }
                lineItems4Point.sort((itemA, itemB) => {
                    const itemAPointRank = me.calcPointRank(itemA, customerRankMultiple);
                    const itemBPointRank = me.calcPointRank(itemB, customerRankMultiple);
                    return itemBPointRank - itemAPointRank;
                });
                return {
                    customerRankMultiple: customerRankMultiple,
                    usePointAmount: cart.appliedGiftCards.length > 0
                        ? Number(cart.appliedGiftCards[0].amountUsed.amount)
                        : 0,
                    lineItem4Point: lineItems4Point,
                };
            }
            //該当商品のポイント倍率を計算
            calcPointRank(lineItem, customerRankMultiple) {
                let pointRank = 1;
                //proper商品の場合
                if (!lineItem.saleFlg) {
                    pointRank = customerRankMultiple;
                }
                //ポイント倍率キャンペーンを考慮
                pointRank *= lineItem.pointMultiple;
                return pointRank;
            }
            //商品タグからポイント倍率キャンペーンの倍率を取得
            getPointMultiple(tags) {
                let ret = 1;
                for (const tag of tags) {
                    const match = tag.match(jun.REGEXP_PNT_MLT);
                    if (match != null) {
                        ret = Number(match[1]);
                        break;
                    }
                }
                return ret;
            }
            /**
             * 20210112 JUN-795
             * 税率を取得
             */
            getTaxRate(lineItem) {
                const tags = lineItem.merchandise.product.tags;
                let taxRate;
                if ($.inArray(jun.TAG_RDC_TAX, tags) == -1) {
                    taxRate = jun.TAX_RATE_NML;
                }
                else {
                    taxRate = jun.TAX_RATE_RDC;
                }
                return taxRate;
            }
            // ポイント利用エリア操作
            //20210112 JUN-795
            async pointControl(cart, first = false, initPt = false) {
                const me = this;
                const userData = jun.cart.Application.userData;
                if (userData == null) {
                    return;
                }
                const subTotal = Number(cart.cost.subtotalAmount.amount);
                //20210112 JUN-795
                const lineItems = cart.lines.edges;
                let total_amount = 0;
                for (const edge of lineItems) {
                    const lineItem = edge.node;
                    const linePrice = lineItem.merchandise.price.amount * lineItem.quantity;
                    const taxRate = me.getTaxRate(lineItem);
                    total_amount += linePrice + linePrice * taxRate;
                }
                total_amount = Math.round(total_amount);
                //20210112 JUN-795
                if (initPt) {
                    // 初回表示時
                    await me.initPointArea(userData);
                    return;
                }
                else {
                    if (first) {
                        // 初回表示時
                        me.showPointArea(userData);
                    }
                    else {
                        // 更新時
                        await me.updatePointArea(userData, total_amount); //20210112 JUN-795
                    }
                }
                //JUN-861 20220519
                // 使用可能なポイント一覧を作成
                //JUN-861 20220613
                const $pointSelect = $(me.el.usePointSelect);
                const applyPoint = me.getPointNum($(me.el.applyPointArea));
                // ポイントエリアの表示判定
                const customerTags = $(me.el.customerTags).data("customerTags");
                const custmerRank = jun.TagsUtil.getCustomerRank(customerTags);
                const availablePoint = me.getPointNum($(me.el.availablePointArea));
                if (custmerRank == "temporary") {
                    $(me.el.customerPointArea).addClass(jun.CLASS_HIDE);
                    $(me.el.customerPointAreaUnavailable).addClass(jun.CLASS_HIDE);
                }
                else if (availablePoint == 0) {
                    //JUN-861 20220519
                    $(me.el.customerPointArea).addClass(jun.CLASS_HIDE);
                    $(me.el.customerPointAreaUnavailable).removeClass(jun.CLASS_HIDE);
                }
                else {
                    $(me.el.usePointSelect).val(applyPoint); //JUN-861 20220519
                    $(me.el.customerPointArea).removeClass(jun.CLASS_HIDE);
                    $(me.el.customerPointAreaUnavailable).addClass(jun.CLASS_HIDE);
                }
            }
            // ポイント利用エリア新規表示
            showPointArea(userData) {
                const me = this;
                $(me.el.availablePointArea).text(jun.FormatUtil.amt(userData.point));
                const applyGiftCardAmount = userData.apply_gift_card_amount;
                if (applyGiftCardAmount > 0) {
                    //JUN-861 20220519
                    //$(me.el.applyPointArea).text(jun.FormatUtil.amt(applyGiftCardAmount / 2));
                    $(me.el.applyPointArea).text(jun.FormatUtil.amt(applyGiftCardAmount / jun.get_point_ratio()));
                }
            }
            // ポイント利用エリアの初期化
            //20210112 JUN-795
            async initPointArea(userData) {
                const me = this;
                // 商品合計が適用中のポイントを下回った場合、ポイント利用が重複しないように一旦リセット
                const applyPointArea = $(me.el.applyPointArea);
                const customApp = new jun.cart.CustomApp(me.el);
                await customApp.requestStopToUsePoint();
                applyPointArea.text(jun.FormatUtil.amt(0));
                $(me.el.availablePointArea).text(jun.FormatUtil.amt(userData.point)); //20220112 JUN-795
                window.location.href = jun.CART_URL;
            }
            // 商品数量変更時のポイント利用エリア再設定
            async updatePointArea(userData, subTotal) {
                const me = this;
                // 商品合計が適用中のポイントを下回った場合、ポイント利用が重複しないように一旦リセット
                const applyPointArea = $(me.el.applyPointArea);
                const applyPoint = me.getPointNum($(me.el.applyPointArea));
                //JUN-861 20220519
                //if (applyPoint * 2 > subTotal) {
                if (applyPoint * jun.get_point_ratio() > subTotal) {
                    if (applyPoint > 0) {
                        const customApp = new jun.cart.CustomApp(me.el);
                        await customApp.requestStopToUsePoint();
                        window.location.href = jun.CART_URL;
                    }
                    applyPointArea.text(jun.FormatUtil.amt(0));
                    // ポイントを差し戻した後の所持ポイントを再表示
                    //$(me.el.availablePointArea).text(jun.FormatUtil.amt(userData.point + applyPoint));
                    $(me.el.availablePointArea).text(jun.FormatUtil.amt(userData.point)); //20220112 JUN-795
                }
            }
            // 要素テキストからポイントを数値で抜き出し
            getPointNum(object) {
                // @ts-ignore
                return Number(object.text().replace(/,/g, ""));
            }
        }
        cart_2.Point = Point;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart) {
        class CustomApp {
            constructor(el) {
                // クラス内での追加element
                this.extendEl = {};
                // メインelement
                this.pointUseClicked = false;
                this.el = $.extend(el, this.extendEl);
            }
            /**
             * カスタマー情報取得リクエスト
             */
            getCustomerData(shopifyCustomerId) {
                jun.set_calling_api_point_get();
                const me = this;
                const init = {
                    method: "get",
                    mode: "cors",
                    credentials: "include",
                };
                const checkout = jun.CheckoutUtil.getCheckoutData();
                const param = "shopify_customer_id=" +
                    shopifyCustomerId +
                    "&checkout_id=" +
                    checkout.id +
                    "&shop_name=" +
                    jun.FRONT_DOMAIN;
                const url = jun.CUSTOM_APP_URL + "/api/point/get?" + param;
                jun.FetchUtil.fetch(url, init, (res) => {
                    if (jun.isDefined(res.error.code)) {
                        jun.remove_calling_api_point_get();
                        if (res.error.code === jun.NOT_LOGGED_IN_ERROR_CODE) {
                            CustomApp.notLoggedInMessage = res.error.message;
                            return;
                        }
                        alert(res.error.message);
                        return;
                    }
                    const data = res.data;
                    //20210112 JUN-795
                    const search_params = new URLSearchParams(window.location.search);
                    jun.cart.Application.userData = {
                        qualica_gid: data.qualica_gid,
                        point: data.point,
                        apply_gift_card_amount: data.apply_gift_card_amount,
                        expire_date: data.expire_date,
                    };
                    if ($(me.el.cartEmptyContent).hasClass(jun.CLASS_HIDE)) {
                        const Point = new jun.cart.Point(me.el);
                        //20210112 JUN-795
                        if (search_params.get("return_flg") === "initPt") {
                            Point.pointControl(checkout, true, true);
                        }
                        else {
                            Point.pointControl(checkout, true);
                        }
                    }
                    jun.remove_calling_api_point_get();
                });
            }
            /**
             * チェックアウト遷移前の残高確認用に、ポイント情報を取り直す
             * 上限時間内に取得できなければ null を返す(エラー表示はしない)
             */
            async refreshCustomerData(shopifyCustomerId, timeoutMs) {
                const sleep = (time) => new Promise((r) => setTimeout(r, time));
                const deadline = Date.now() + timeoutMs;
                // api同時実行抑制
                while (jun.is_calling_api_point_get()) {
                    if (Date.now() >= deadline) {
                        return null;
                    }
                    await sleep(200);
                }
                const controller = new AbortController();
                const timer = setTimeout(() => controller.abort(), deadline - Date.now());
                jun.set_calling_api_point_get();
                try {
                    const checkout = jun.CheckoutUtil.getCheckoutData();
                    const param = "shopify_customer_id=" +
                        shopifyCustomerId +
                        "&checkout_id=" +
                        checkout.id +
                        "&shop_name=" +
                        jun.FRONT_DOMAIN;
                    const res = await fetch(jun.CUSTOM_APP_URL + "/api/point/get?" + param, {
                        method: "get",
                        mode: "cors",
                        credentials: "include",
                        signal: controller.signal,
                    });
                    if (!res.ok) {
                        return null;
                    }
                    const json = await res.json();
                    if (jun.isDefined(json.error.code)) {
                        return null;
                    }
                    jun.cart.Application.userData = {
                        qualica_gid: json.data.qualica_gid,
                        point: json.data.point,
                        apply_gift_card_amount: json.data.apply_gift_card_amount,
                        expire_date: json.data.expire_date,
                    };
                    return jun.cart.Application.userData;
                }
                catch (e) {
                    return null;
                }
                finally {
                    clearTimeout(timer);
                    jun.remove_calling_api_point_get();
                }
            }
            /**
             * ポイント利用リクエスト
             */
            async requestUsePoint(event) {
                const me = event.data;
                if (CustomApp.notLoggedInMessage !== null) {
                    alert(CustomApp.notLoggedInMessage);
                    me.goToLoginIfNotLoggedIn(jun.NOT_LOGGED_IN_ERROR_CODE);
                    return;
                }
                const userData = jun.cart.Application.userData;
                if (userData == null || me.pointUseClicked) {
                    return;
                }
                me.pointUseClicked = true;
                let usePointSelect = $(me.el.usePointSelect).val();
                //JUN-1149 22020914
                let checkout = await jun.CheckoutUtil.refreshCheckoutData();
                // 「利用しない」を選択した場合、ポイント適用をリセット
                //JUN-861 20220613
                if (!jun.get_point_ver_2nd()) {
                    if (usePointSelect == 0) {
                        await me.requestStopToUsePoint();
                        checkout = jun.CheckoutUtil.getCheckoutData();
                        if (checkout.appliedGiftCards.length !== 0) {
                            location.reload();
                        }
                        return;
                    }
                }
                else {
                    if (usePointSelect == 0 || usePointSelect === "") {
                        //JUN-861 20220519
                        await me.requestStopToUsePoint();
                        checkout = jun.CheckoutUtil.getCheckoutData();
                        if (checkout.appliedGiftCards.length !== 0) {
                            location.reload();
                        }
                        return;
                    }
                }
                //JUN-861 20220613
                if (jun.get_point_ver_2nd()) {
                    //JUN-861 20220519
                    usePointSelect = jun.FormatUtil.hankaku2Zenkaku(usePointSelect);
                    if (!jun.FormatUtil.is_hankaku_number(usePointSelect)) {
                        me.pointUseClicked = false;
                        alert("数値を半角で入力してください。");
                        $(me.el.usePointSelect).focus();
                        return;
                    }
                    usePointSelect = jun.FormatUtil.changeInteger(usePointSelect);
                    $(me.el.usePointSelect).val(usePointSelect);
                    if (jun.getTotalAmountLineItems() < usePointSelect * jun.get_point_ratio()) {
                        me.pointUseClicked = false;
                        alert("利用ポイントは注文合計金額以下を入力してください。");
                        $(me.el.usePointSelect).focus();
                        return;
                    }
                }
                // 既にポイントを適用していた場合、重複しないように一旦リセット
                const Point = new jun.cart.Point(me.el);
                //JUN-861 20220613
                if (jun.get_point_ver_2nd()) {
                    //JUN-861 20220607
                    if ($("#my-point") != undefined &&
                        Point.getPointNum($("#my-point")) < usePointSelect * jun.get_point_ratio()) {
                        me.pointUseClicked = false;
                        alert("利用可能なポイント上限を超えています。");
                        $(me.el.usePointSelect).focus();
                        return;
                    }
                }
                //JUN-1149 22020914
                let giftCard = jun.CheckoutUtil.getApplyGiftData(checkout);
                //const applyPoint = Point.getPointNum($(me.el.applyPointArea));
                //if (giftCard.id != undefined && giftCard.id !== 0) {
                //    await me.requestStopToUsePoint();
                //}
                if (giftCard !== null && giftCard.id != undefined && giftCard.id != "") {
                    await me.requestStopToUsePoint();
                }
                checkout = jun.CheckoutUtil.getCheckoutData();
                const init = {
                    method: "post",
                    mode: "cors",
                    // backend はログイン時に発行した Cookie で本人確認する
                    credentials: "include",
                    headers: me.getHeader(),
                    body: JSON.stringify({
                        qualica_gid: userData.qualica_gid,
                        use_point: usePointSelect,
                        checkout_id: checkout.id,
                        shop_name: jun.FRONT_DOMAIN,
                    }),
                };
                jun.FetchUtil.fetch(jun.CUSTOM_APP_URL + "/api/point/use", init, (res) => {
                    if (jun.isDefined(res.error.code)) {
                        alert(res.error.message);
                        me.pointUseClicked = false;
                        me.goToLoginIfNotLoggedIn(res.error.code);
                        return;
                    }
                    location.reload();
                });
            }
            /**
             * ポイント使用中止リクエスト
             */
            async requestStopToUsePoint() {
                const me = this;
                const checkout = jun.CheckoutUtil.getCheckoutData();
                if (checkout.appliedGiftCards.length == 0) {
                    alert("ポイントが適用されていません。");
                    me.pointUseClicked = false;
                    return;
                }
                const init = {
                    method: "post",
                    mode: "cors",
                    credentials: "include",
                    headers: me.getHeader(),
                    body: JSON.stringify({
                        checkout_id: checkout.id,
                        gift_card_id_store_front: checkout.appliedGiftCards[0].id,
                        shop_name: jun.FRONT_DOMAIN,
                    }),
                };
                await jun.FetchUtil.fetch(jun.CUSTOM_APP_URL + "/api/point/stop_to_use", init, (res) => {
                    if (jun.isDefined(res.error.code)) {
                        if (res.error.code === jun.NOT_LOGGED_IN_ERROR_CODE) {
                            alert(res.error.message);
                        }
                        else {
                            alert("会員情報の取得に失敗しました。");
                        }
                        me.pointUseClicked = false;
                        me.goToLoginIfNotLoggedIn(res.error.code);
                        return;
                    }
                });
            }
            /**
             * backend の本人確認に失敗していたら、ログイン後にカートへ戻るようにしてログイン画面へ移動する
             */
            goToLoginIfNotLoggedIn(errorCode) {
                if (errorCode !== jun.NOT_LOGGED_IN_ERROR_CODE) {
                    return;
                }
                location.href =
                    "/account/login?cart_url=" + encodeURIComponent(location.href);
            }
            getHeader() {
                return {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                };
            }
        }
        // カート表示時のポイント取得で backend の本人確認に失敗したときのメッセージ。
        // カートを開いただけでは案内せず、ポイント利用ボタンを押したときに案内する
        // （CustomApp はカート内の複数箇所で new されるため static に持つ）
        CustomApp.notLoggedInMessage = null;
        cart.CustomApp = CustomApp;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart) {
        var tpl;
        (function (tpl) {
            /**
             * 商品行作成処理
             */
            function lineItem(cartEl, lineItem, pointTimes) {
                var _a;
                const merchandise = lineItem.merchandise;
                const nowUrl = new URL(window.location.href);
                let productUrl = "javascript:void(0);";
                let productCode = merchandise.product.productCode;
                if (productCode != null) {
                    //絶対パスで記述
                    productUrl = "/products/" + merchandise.product.handle;
                }
                let html = `
          <!-- 商品単位 -->
          <div class="c-box-9__unit" data-cart-item data-cart-item-title="${merchandise.product.title}" data-line-item-id="${lineItem.id}">
            <!-- 商品画像 -->
            <div class="c-box-9__img">
              <a href="${productUrl}">
                <img class="cart__image ${merchandise.image.src == null ? "hide" : jun.BLANK}" src="${merchandise.image.src}" alt="${merchandise.image.altText}" data-cart-item-image>
              </a>
            </div>
            <div class="c-box-9__detail">
              <div class="c-box-9__product-info">
        `;
                let soldOutSku = nowUrl.searchParams.get("sold_out_sku");
                if (soldOutSku != null && soldOutSku == merchandise.sku) {
                    html += `<span class="sold-out">品切れ中</span>`;
                }
                let optionsArr = [];
                for (const option of merchandise.selectedOptions) {
                    optionsArr.push(option.value);
                }
                // カラー名をmetafieldから取得、ない場合はoptionsから
                let colorSizeName = "";
                if (((_a = merchandise === null || merchandise === void 0 ? void 0 : merchandise.colorName) === null || _a === void 0 ? void 0 : _a.value) === undefined) {
                    colorSizeName = optionsArr.join(" / ");
                }
                else {
                    let colorCdMatch = optionsArr[0].match(/（[a-zA-Z0-9]+）/);
                    let colorCd = colorCdMatch ? colorCdMatch[0] : "";
                    colorSizeName = `${merchandise.colorName.value}${colorCd} / ${optionsArr[1]}`;
                }
                html += `
          <a href="${productUrl}" class="c-box-9__name">${merchandise.product.title}</a>
          <p class="c-box-9__color">${colorSizeName}</p>
        `;
                if (pointTimes > 1) {
                    html += `<p class="c-box-9__coupon">ポイント${pointTimes}倍対象</p>`;
                }
                html += `
          </div>
        `;
                html += `
          <div class="c-box-9__cat sp-hide">
        `;
                let reserveFlg = jun.PRD_NML_FLG;
                if (lineItem.merchandise.reserveFlg != undefined &&
                    lineItem.merchandise.reserveFlg.value != "") {
                    reserveFlg = lineItem.merchandise.reserveFlg.value;
                }
                if (reserveFlg == jun.PRD_RSV_FLG) {
                    html += `
              <p class="c-box-9__reserved">
                <strong>予約商品</strong>
            `;
                    const rddString = jun.cart.tpl.getReserveDeliveryDate(merchandise);
                    if (rddString != jun.BLANK) {
                        html += `
                  ${rddString}<br>お届け予定
                `;
                    }
                    html += `
              </p>
            `;
                }
                html += `
        </div>
        `;
                html += `
          <ul class="c-box-9__list">
            <li class="c-box-9__item">
              <span class="c-box-9__term">価格<span class="tax">（税抜）</span></span>
              <span class="c-box-9__separation">:</span>
              <span class="c-box-9__desc">
        `;
                const originalPrice = Number(merchandise.originalPrice.value);
                if (originalPrice && originalPrice != merchandise.price.amount) {
                    html += `
              <span class="proper">&yen;${jun.FormatUtil.amt(Number(originalPrice))}</span>
              <span class="discount">&yen;<span data-line-item-price>${jun.FormatUtil.amt(parseInt(merchandise.price.amount))}</span></span>
            `;
                }
                else {
                    html += `
              <span>&yen;<span data-line-item-price>${jun.FormatUtil.amt(parseInt(merchandise.price.amount))}</span></span>
            `;
                }
                html += `
            </span>
          </li>
          <li class="c-box-9__item">
            <span class="c-box-9__term">数量</span>
            <span class="c-box-9__separation">:</span>
            <span class="c-box-9__desc">
              <span class="c-form-4__select">
                <select name="quantity" name="updates[]" value="${lineItem.quantity}" data-quantity-input data-product-id="${lineItem.id}">
        `;
                let max = jun.MAX_QUANTITY;
                if (lineItem.merchandise.product.purchase_limit) {
                    max = lineItem.merchandise.product.purchase_limit.value;
                }
                else if (lineItem.merchandise.purchase_limit) {
                    max = lineItem.merchandise.purchase_limit.value;
                }
                for (let num = 0; num <= max; num++) {
                    if (lineItem.quantity == num) {
                        html += `<option value="${num}" selected>${num}</option>`;
                    }
                    else {
                        html += `<option value="${num}">${num}</option>`;
                    }
                }
                html += `
                      </select>
                    </span>
                  </span>
                </li>
                <li class="c-box-9__item">
                  <span class="c-box-9__term subtotal">小計<span class="tax">（税抜）</span></span>
                  <span class="c-box-9__separation">:</span>
                  <span class="c-box-9__desc subtotal">&yen;<span data-line-item-price-total>${jun.FormatUtil.amt(merchandise.price.amount * lineItem.quantity)}</span></span>
                  <a href="#" class="c-box-9__delete" data-cart-remove>削除</a>
                </li>
              </ul>
            </div>
            <!-- / .c-box-9__detail -->
          </div>
          <!-- / .c-box-9__unit -->
        `;
                return html;
            }
            tpl.lineItem = lineItem;
            /**
             * 小計行作成処理
             */
            function subTotalPrice(params) {
                let html = `
            <div class="c-box-10__upper">
              <div class="c-box-10__unit">
                <div class="c-box-10__line">
                  <p class="c-box-10__term">小計<span class="tax">（税抜）</span></p>
                  <p class="c-box-10__price">&yen;<span data-line-items-subtotal>${jun.FormatUtil.amt(Math.round(params.subTotal))}</span></p>
                </div>
                <div class="c-box-10__line">
                  <p class="c-box-10__term">消費税（10%対象）</p>
                  <p class="c-box-10__price">&yen;<span data-line-items-taxnml-total>${jun.FormatUtil.amt(Math.round(params.taxNmlTotal))}</span></p>
                </div>
                <div class="c-box-10__line">
                  <p class="c-box-10__term">消費税（8%対象）</p>
                  <p class="c-box-10__price">&yen;<span data-line-items-taxrdc-total>${jun.FormatUtil.amt(Math.round(params.taxRdcTotal))}</span></p>
                </div>
              </div>
            </div>
            <div class="c-box-10__lower">
              <div class="c-box-10__unit">
                <div class="c-box-10__line">
                  <p class="c-box-10__term total">注文合計</p>
                  <p class="c-box-10__price total">&yen;<span data-line-items-total>${jun.FormatUtil.amt(Math.round(params.total))}</span></p>
                </div>
            `;
                // 未ログインの場合、非表示
                if (params.customerId) {
                    html += `
                <div class="c-box-10__line">
                  <p class="c-box-10__term point">獲得予定ポイント</p>
                  <p class="c-box-10__price point"><span data-line-items-point>${jun.FormatUtil.amt(Math.round(params.calcPoint))}</span>pt</p>
                </div>
            `;
                }
                html += `
             </div><!-- / .c-box-10__unit -->
        `;
                // shippingがない = 無料対象の場合、非表示
                if (params.shipping > 0) {
                    html += `
                <div class="c-box-10__unit shipping">
                  <div class="c-box-10__line">
                    <p class="c-box-10__term shipping">送料<span class="tax">（税込）</span></p>
                    <p class="c-box-10__price shipping">¥500</p>
                  </div>
                  <!--
                  <div class="c-box-10__line">
                    <p class="c-box-10__term shipping-info">送料無料まであと<span data-line-items-shipping>${jun.FormatUtil.amt(Math.round(params.shipping))}</span>円 (税込)</p>
                  </div>
                  <div class="c-box-10__line">
                    <p class="c-box-10__term shipping-note">5,500円（税込）のお買い上げで送料無料となります</p>
                  </div>
                  -->
                </div>
                <!-- / .c-box-10__unit -->
            `;
                }
                else {
                    html += `
                <div class="c-box-10__unit shipping">
                  <div class="c-box-10__line">
                    <p class="c-box-10__term free-shipping">送料無料</p>
                  </div>
                </div><!-- / .c-box-10__unit -->
            `;
                }
                html += `  
          </div><!-- / .c-box-10__lower -->
        `;
                return html;
            }
            tpl.subTotalPrice = subTotalPrice;
            /**
             * 20220304 JUN-871 カートにお知らせ文言を追加したい
             */
            function warningMessage(params) {
                let html = `
      <!-- -->
      <div class="item">
        <div class="title">${params.title}（${params.post_dt}）</div>
        <div class="text">
        ${params.lead_sentence}
        </div>
      </div><!-- / .item -->
      `;
                return html;
            }
            tpl.warningMessage = warningMessage;
            /**
             * 使用ポイント選択肢作成処理
             */
            //JUN-861 20220519
            function usePointSelectOption(point, applyPoint) {
                let selected = "";
                if (point / jun.get_point_ratio() == applyPoint) {
                    selected = " selected";
                }
                return `
            <option value="${point / jun.get_point_ratio()}"${selected}>${jun.FormatUtil.amt(point)}円分</option>
        `;
            }
            tpl.usePointSelectOption = usePointSelectOption;
            /**
             * お届け予定日を取得
             */
            function getReserveDeliveryDate(merchandise) {
                let rddString = jun.BLANK;
                const reserveDeliveryDate = merchandise.reserveDeliveryDate;
                if (reserveDeliveryDate == null || reserveDeliveryDate.value == jun.BLANK) {
                    return rddString;
                }
                rddString = jun.FormatUtil.getDateFormat4Season(reserveDeliveryDate.value);
                return rddString;
            }
            tpl.getReserveDeliveryDate = getReserveDeliveryDate;
        })(tpl = cart.tpl || (cart.tpl = {}));
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart) {
        class WarningDisplay {
            constructor(el) {
                // クラス内での追加element
                this.extendEl = {
                    warningItems: "[data-warning-area]",
                };
                this.el = $.extend(el, this.extendEl);
            }
            /**
                 20220304 JUN-871 カートにお知らせ文言を追加したい
                 */
            async addWarningDisplayArea() {
                const me = this;
                const warningEl = me.el;
                const warningList = await me.getWarningList();
                if (warningList === false || warningList.length == 0) {
                    return;
                }
                let $warningItems = [];
                for (const params of warningList) {
                    $warningItems.push($(jun.cart.tpl.warningMessage(params)));
                }
                if ($warningItems.length > 0) {
                    $(warningEl.warningItems).append($warningItems);
                    $(warningEl.warningItems).removeClass(jun.CLASS_HIDE);
                }
            }
            /**
                 注意文言一覧を取得
                 */
            async getWarningList() {
                const init = {
                    method: "get",
                    mode: "cors",
                    credentials: "include",
                    cache: "force-cache",
                    headers: {
                        Accept: "application/json",
                    },
                };
                const url = jun.CMS_URL + "/api/informations";
                let response = false;
                await jun.FetchUtil.fetch(url, init, (res) => {
                    if (res.result) {
                        response = res.informations;
                    }
                    else {
                        response = false;
                    }
                });
                return response;
            }
        }
        cart.WarningDisplay = WarningDisplay;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
var jun;
(function (jun) {
    var cart;
    (function (cart_3) {
        class DataLayerTag {
            constructor() {
                this.params = this.convertParams();
            }
            write() {
                if (location.hostname === "saturdaysnyc.co.jp" ||
                    location.hostname === "stg-store.saturdaysnyc.co.jp") {
                    const dataLayerScript = this.generateScript();
                    $("#cart-tag-start-mark").after($(dataLayerScript));
                    const gtmScriptInHeader = this.getGtmScriptInHeader();
                    $("head").append($(gtmScriptInHeader));
                    const gtmScriptInBody = this.getGtmInBodyScript();
                    $("body").prepend($(gtmScriptInBody));
                }
                // デバッグ
                if (location.hostname !== "saturdaysnyc.co.jp") {
                    this.appendNodeForDebug();
                }
            }
            generateScript() {
                const stringItems = this.params.items.map(function (items) {
                    return ("{\n" +
                        'itemid: "' +
                        items.itemId +
                        '",\n' +
                        'itemskuid: "' +
                        items.itemSkuId +
                        '",\n' +
                        'itemecid: "' +
                        items.itemEcId +
                        '",\n' +
                        'color_cd: "' +
                        items.colorCd +
                        '",\n' +
                        'size_nm: "' +
                        items.sizeCd +
                        '",\n' +
                        "itemprice:" +
                        items.itemPrice +
                        ",\n" +
                        "itempcs:" +
                        items.itemPcs +
                        "\n" +
                        "}\n");
                });
                const result = `
                <script>
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'ad':{
                            'item': [` +
                    stringItems.join(",") +
                    `]
                        }
                    });
                </script>
            `;
                return result;
            }
            getGtmScriptInHeader() {
                const result = ``;
                return result;
            }
            getGtmInBodyScript() {
                const result = ``;
                return result;
            }
            convertParams() {
                let result = { items: [] };
                const cart = jun.CheckoutUtil.getCheckoutData();
                const lines = cart.lines.edges;
                if (lines.length < 1) {
                    return result;
                }
                lines.forEach(function (item) {
                    const node = item.node;
                    const systemData = JSON.parse(node.merchandise.systemData.value);
                    let variantId = "";
                    // JUN-796 20220527
                    // variantIdがエンコードされていたら、デコード処理をする(shopify 2022-04からエンコードされずに返ってくる)
                    if (jun.isBase64(node.merchandise.id)) {
                        variantId = atob(node.merchandise.id).replace("gid://shopify/ProductVariant/", "");
                    }
                    else {
                        variantId = node.merchandise.id.replace("gid://shopify/ProductVariant/", "");
                    }
                    const val = {
                        itemId: systemData["商品コード"],
                        itemSkuId: systemData["商品コード"] +
                            "_" +
                            systemData["カラーコード"] +
                            "_" +
                            systemData["サイズコード"],
                        itemEcId: variantId,
                        colorCd: systemData["カラーコード"],
                        sizeCd: systemData["サイズコード"],
                        itemPrice: parseInt(node.merchandise.price.amount).toString(),
                        itemPcs: node.quantity,
                    };
                    result.items.push(val);
                });
                return result;
            }
            appendNodeForDebug() {
                const target = $("#debug-tag-cart-data-layer");
                this.params.items.map((item) => {
                    const dataMap = {
                        itemid: item.itemId,
                        itemskuid: item.itemSkuId,
                        itemecid: item.itemEcId,
                        color_cd: item.colorCd,
                        size_nm: item.sizeCd,
                        itemprice: item.itemPrice,
                        itempcs: item.itemPcs,
                    };
                    const parent = $("<span>");
                    Object.keys(dataMap).map((k) => {
                        parent.append($("<span>", { "data-key": k, text: dataMap[k] }));
                    });
                    target.append(parent);
                });
            }
        }
        cart_3.DataLayerTag = DataLayerTag;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
/// <reference path="../common/common.ts" />
/// <reference path="../common/tpl.ts" />
/// <reference path="../common/graphql.ts" />
/// <reference path="./graphql.ts" />
/// <reference path="./cart_item.ts" />
/// <reference path="./point.ts" />
/// <reference path="./custom_app.ts" />
/// <reference path="./tpl.ts" />
/// <reference path="./warning_display.ts" />
/// <reference path="./data_layer_tag.ts" />
var jun;
(function (jun) {
    var cart;
    (function (cart) {
        // チェックアウト遷移前にポイント残高を取り直す際の待ち時間の上限(ミリ秒)
        cart.POINT_RECHECK_TIMEOUT = 10000;
        class Application extends jun.AbstractApplication {
            constructor() {
                super(...arguments);
                this.el = {
                    cartEmptyContent: "[data-empty-page-content]",
                    cartContent: "[data-cart-wrapper]",
                    lineItems: "[data-cart-line-items]",
                    cartRemoveBtn: "[data-cart-remove]",
                    productQuantity: "[data-quantity-input]",
                    shopifyCustomerId: "[data-shopify-customer-id]",
                    usePointBtn: "[data-use-point-request]",
                    stopUsePointBtn: "[data-stop-use-point-request]",
                    usePointSelectArea: "[data-use-point-select-area]",
                    usePointSelect: "[data-use-point-select]",
                    checkoutBtn: "[name=checkout]",
                    calcPoint: "[data-line-items-point]",
                    applyPointArea: "[data-apply-point]",
                    customerTags: "[data-customerTags]",
                    yappliWheelioTags: "[id=yappli-wheel-banner]", // 20211221 JUN-752
                };
            }
            init() {
                const me = this;
                const cartEl = me.el;
                //JUN-861 20220613
                if (!jun.get_point_ver_2nd()) {
                    $(".point-second").remove();
                }
                else {
                    $(".point-first").remove();
                }
                // lineitem関連
                const cartItem = new jun.cart.CartItem(me.el);
                cartItem.addCartArea();
                $(cartEl.lineItems).on("click", cartEl.cartRemoveBtn, cartItem, cartItem.removeLineItem);
                $(cartEl.lineItems).on("change", cartEl.productQuantity, cartItem, cartItem.updateLineItem);
                $(cartEl.checkoutBtn).on("click", cartItem, cartItem.tranCheckout);
                // point関連
                const $customerId = $(cartEl.shopifyCustomerId);
                if ($customerId.length > 0) {
                    const customApp = new jun.cart.CustomApp(me.el);
                    // api同時実行抑制
                    const sleep = (time) => new Promise((r) => setTimeout(r, time));
                    (async function () {
                        for (let i = 0; i < 10; i++) {
                            if (jun.is_calling_api_point_get()) {
                                await sleep(100 * 2 ** i);
                                continue;
                            }
                            break;
                        }
                        customApp.getCustomerData($customerId.data("shopify-customer-id"));
                    })();
                    $(cartEl.usePointBtn).on("click", customApp, customApp.requestUsePoint);
                }
                // ログインページへのリンクを作成
                cartItem.addLoginLink();
                // 20220304 JUN-871 カートにお知らせ文言を追加したい
                //const warningItem = new jun.cart.WarningDisplay(me.el);
                //warningItem.addWarningDisplayArea();
                // 20211221 JUN-752
                if (window.matchMedia("(max-width: 750px)").matches) {
                    if (jun.isBetWeenTerm(jun.WHEEL_FROM_TIME, jun.WHEEL_TO_TIME)) {
                        $(cartEl.yappliWheelioTags).show();
                    }
                    $(document).on("click", ".wlo_try_luck_btn", function () {
                        $("body").addClass("scratch-open");
                        $(".wlo_logo").hide();
                        $(".wlo_form").attr("style", "margin-top:-80px;");
                        if ($(".wlo_try_luck_btn").text() == "クーポンコードをコピー") {
                            $("body").removeClass("scratch-open");
                            $(".wlo_logo").show();
                            $("#wheelio").attr("style", "display:none!important");
                        }
                    });
                    $(cartEl.yappliWheelioTags).on("click", function () {
                        if (jun.isBetWeenTerm(jun.WHEEL_FROM_TIME, jun.WHEEL_TO_TIME)) {
                            $("#wheelio").attr("style", "display:block!important");
                            $(".wlo_pulltab").trigger("click");
                        }
                    });
                    $(document).on("click", ".wlo_close", function () {
                        if (jun.isBetWeenTerm(jun.WHEEL_FROM_TIME, jun.WHEEL_TO_TIME)) {
                            $("body").removeClass("scratch-open");
                            $(".wlo_logo").show();
                            $("#wheelio").attr("style", "display:none!important");
                        }
                    });
                }
                // タグ
                //(new DataLayerTag()).write();
            }
            display() {
                //何もしない
            }
        }
        // ユーザー情報
        Application.userData = null;
        cart.Application = Application;
    })(cart = jun.cart || (jun.cart = {}));
})(jun || (jun = {}));
jun.ready(new jun.cart.Application());
